import React from 'react';
import axios from 'axios';
import { Toaster, toast } from 'react-hot-toast';
import { Link } from 'react-router-dom';
import ProfileFeed from './profile/ProfileFeed';
import InfiniteScroll from 'react-infinite-scroll-component';
import ShakaPlayerComponent from './ShakaPlayerComponent';
import ProfilePic from '../ProfilePicTemp.png';
import { Dialog, Transition, TransitionChild, DialogPanel, DialogTitle } from '@headlessui/react';
import MoonLoader from 'react-spinners/MoonLoader';
import Cards from 'react-credit-cards-2';
import "react-credit-cards-2/dist/es/styles-compiled.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
// import { CreditCard, PaymentForm, CashAppPay, GooglePay } from 'react-square-web-payments-sdk';
import { loadStripe } from '@stripe/stripe-js';
import { EmbeddedCheckoutProvider, EmbeddedCheckout } from '@stripe/react-stripe-js';
// import clerk from '../utils/clerk';
import { Virtuoso } from "react-virtuoso";
import { getToken, getBearer, forceLogout } from '../hooks/AuthProvider';
import TwoFacModal from './TwoFacModal';
import FeedComponent from './FeedComponent';

import {
    formatCreditCardNumber,
    formatCVC,
    formatExpirationDate,
    formatFormData,
    isCardExpiryValid,
    isCardCVCValid,
    isCardNumberValid,
} from '../utils/cardUtils';
import AuthCode, { AuthCodeRef } from 'react-auth-code-input';
import { authClient } from '../hooks/authClient';
import Tabs from './Tabs';

type props = {
    postID: string | null;
};

interface Post {
    postID: string;
    profilePic?: string;
    username: string;
    displayName: string;
    followers: number;
    title: string;
    description: string;
    access: boolean;
    isLive: boolean;
    content?: {
        widevineURL: string;
        fairplayURL: string;
        type: string;
        id: string;
        filename: string;
        contentWidth: number;
        contentHeight: number;
        prevAccessed: boolean;
    }[];
    isPostLiked: boolean;
    likes: number;
    comments: number;
    price: number;
    isHidden: boolean;
    taxInclusivePrice: number;
    taxIncluded: boolean;
}

type state = {
    loading: boolean;
    subscriptions: any[];
    user: any[];
    username: string;
    following: boolean;
    followers: number;
    isSelf: boolean;
    items: Post[];
    pageNum: number;
    hasMore: boolean;
    loadingMore: boolean;
    followingUser: boolean;
    bannerURL: string;
    verified: boolean;
    profileModalShown: boolean;
    profileUploading: boolean;
    purchaseShow: boolean;
    purchaseData: Post | null;
    number: string;
    expiry: string;
    name: string;
    cardFocused: string;
    ccv: string;
    isPaymentActive: boolean;
    purchaseID: string;
    myName: string;
    fname: string;
    lname: string;
    email: string;
    commentModal: boolean;
    comments: comment[] | null;
    activePostID: string | null;
    commentData: string | null;
    isLive: boolean;
    fromPostID: string | null;
    creatorSubPrice: number;
    followModal: boolean;
    planID: string;
    twoFacSuccess: boolean;
    totpEnabled: boolean;
    userSuspended: boolean;
    openMenuPostID: string | null;
    openCommentMenuIndex: number | null;
    title: string;
    category: string;
    desc: string;
    reportModal: boolean;
    reportPost: string;
    reportModalDescription: string;
    editModal: boolean;
    editTitle: string;
    editDesc: string;
    editPostID: string;
    takedownModal: boolean;
    takedownPostID: string;
    takedownTitle: string;
    paymentProviders: Provider[];
    isTaxInclusive: boolean;
    taxInclusivePrice: number;
    authorizingPurchase: boolean;
    purchasePollInterval: NodeJS.Timeout | null;
    purchasePollAttempts: number;
    authorizationToken: string | null;
}

type Provider = {
    provider: string;
    label: string;
    type: string;
    enabled: boolean;
}

type comment = {
    data: string;
    createdAt: string;
    username: string;
    profilePic: string;
    postID: string;
}

type post = {
    access: boolean;
    createdAt: string;
    description: string;
    followers: number;
    isPostLiked: boolean;
    likes: number;
    postID: string;
    price: number;
    profilePic: {
        profilePic: string;
        _id: string;
    };
    status: string;
    title: string;
    username: string;
}
  
// interface FeedState {
//     items: Post[];
// }

export default class UserComponent extends React.PureComponent<props, state> {
    private usernameInput = React.createRef<HTMLInputElement>();
    private displayNameInput = React.createRef<HTMLInputElement>();
    private closeModalBTN = React.createRef<HTMLButtonElement>();
    private payBTN = React.createRef<HTMLButtonElement>();
    private commentInput = React.createRef<HTMLInputElement>();
    private AuthInputRef = React.createRef<AuthCodeRef>();
    private reportSubmit = React.createRef<HTMLButtonElement>();
    private editSubmit = React.createRef<HTMLButtonElement>();
    // private reportModalDescription = React.createRef<HTMLTextAreaElement>();
    
    constructor(props: any) {
        super(props);
        this.state = {
            loading: true,
            subscriptions: [],
            user: [],
            username: '',
            following: false,
            followers: 0,
            isSelf: false,
            items: [],
            pageNum: 0,
            hasMore: true,
            loadingMore: false,
            followingUser: false,
            verified: false,
            bannerURL: '',
            profileModalShown: false,
            profileUploading: false,
            purchaseShow: false,
            purchaseData: null,
            number: '4243 1111 1111 1111',
            expiry: '01/26',
            ccv: '221',
            name: 'Demo Name',
            cardFocused: '',
            isPaymentActive: false,
            purchaseID: '',
            myName: '',
            fname: '',
            lname: '',
            email: '',
            commentModal: false,
            comments: null,
            activePostID: null,
            commentData: null,
            isLive: false,
            fromPostID: null,
            creatorSubPrice: 0.00,
            followModal: false,
            planID: '',
            twoFacSuccess: false,
            totpEnabled: false,
            userSuspended: false,
            openMenuPostID: null as string | null,
            openCommentMenuIndex: null,
            title: '',
            category: '',
            desc: '',
            reportModal: false,
            reportPost: '',
            reportModalDescription: '',
            editModal: false,
            editTitle: '',
            editDesc: '',
            editPostID: '',
            takedownModal: false,
            takedownPostID: '', 
            takedownTitle: '',
            paymentProviders: [],
            isTaxInclusive: false,
            taxInclusivePrice: 0.00,
            authorizingPurchase: false,
            purchasePollInterval: null,
            purchasePollAttempts: 0,
            authorizationToken: null,
        }
        this.toggleFollow = this.toggleFollow.bind(this);
        this.fetchData = this.fetchData.bind(this);
        this.inputChange = this.inputChange.bind(this);
        this.closeCommentModal = this.closeCommentModal.bind(this);
        this.openCommentModal = this.openCommentModal.bind(this);
        this.checkoutSession = this.checkoutSession.bind(this);
        this.loadStripeComponent = this.loadStripeComponent.bind(this);
        this.authCodeInput = this.authCodeInput.bind(this);
        this.AuthInputRef = React.createRef();
        this.checkPurchaseStatus = this.checkPurchaseStatus.bind(this);
        this.startPurchasePolling = this.startPurchasePolling.bind(this);
        this.stopPurchasePolling = this.stopPurchasePolling.bind(this);
        this.refetchUserFeed = this.refetchUserFeed.bind(this);
        // this.commentInput = this.commentInput.bind(this);
    }

    componentDidMount(): void {
        var username = window.location.pathname.split('/')[3];

        const script = document.createElement('script');
        script.src = '/jsencrypt.min.js';
        script.async = true;
        document.body.appendChild(script);

        // Get PostID from query params in URL
        var postID = new URLSearchParams(window.location.search).get('postID');
        console.log(postID);

        // Check for purchaseID or session_id query parameter (backward compatibility)
        const urlParams = new URLSearchParams(window.location.search);
        const purchaseID = urlParams.get('purchaseID') || urlParams.get('session_id');
        
        if (purchaseID) {
            this.setState({ 
                authorizingPurchase: true, 
                purchaseID: purchaseID,
                purchasePollAttempts: 0
            });
            this.startPurchasePolling(purchaseID);
        }

        // @ts-ignore
        // console.log(navigator.connection.type);

        // this.setState({username: username});
        // var token = localStorage.getItem('token');
        // if (clerk.user) {
            // clerk.session?.getToken().then(async (token) => {
                // Axios request to backend ...
        axios.get(`${process.env.REACT_APP_API_URL}api/v1/user/${username}`, { headers: { 'x-auth-token': getToken() } }).then((res: any) => {
            // console.log(res.data.user);
            if (res.data.user === null) {
                // Redirect to 404
                window.location.href = '/404';
            } else {
                console.log(res.data.creatorSubPrice);
                if (res.data.creatorSubPrice.length === 0) {
                    this.setState({ myName: res.data.self.displayName, user: res.data.user, username: username, loading: false, following: res.data.following, isSelf: res.data.isUser, bannerURL: res.data.bannerPic, followers: res.data.followers, isLive: res.data.user.isLive, creatorSubPrice: 0.00, isTaxInclusive: res.data.creatorSubPrice[0].taxIncluded, taxInclusivePrice: res.data.creatorSubPrice[0].taxInclusivePrice });
                } else {
                    this.setState({ myName: res.data.self.displayName, user: res.data.user, username: username, loading: false, following: res.data.following, isSelf: res.data.isUser, bannerURL: res.data.bannerPic, followers: res.data.followers, isLive: res.data.user.isLive, creatorSubPrice: res.data.creatorSubPrice[0].price, planID: res.data.creatorSubPrice[0]._id, taxInclusivePrice: res.data.creatorSubPrice[0].taxInclusivePrice, isTaxInclusive: res.data.creatorSubPrice[0].taxIncluded });
                }
            }
        }).catch(err => {
            console.log(err.response);
            if (err.response) {
                if (err.response.data.msg === 'Not Verified') {
                    forceLogout();
                } else if (err.response.data.msg === 'User not found') {
                    window.location.href = '/404';
                }
            }
            console.error(err);
        });

        if (postID !== null) {
            this.setState({ fromPostID: postID });

            axios.get(`${process.env.REACT_APP_API_URL}api/v1/user/${username}/feed?fromPost=${postID}`, { headers: { 'x-auth-token': getToken()} }).then((res) => {
                // console.log(res.data);
                this.setState({ items: res.data.posts, pageNum: 1, followingUser: true, authorizationToken: res.data.authorizationToken || null });
            }).catch((err) => {
                console.log(err);
                if (err.response.data.msg === 'User not following') {
                    this.setState({followingUser: false})
                } else if (err.response.data.msg === 'No posts found') {
                    this.setState({ hasMore: false, followingUser: true });
                } else if (err.response.data.msg === 'Not Verified' || err.response.data.error === 'Missing Auth Token') {
                    forceLogout();
                }
            });
        } else {
            axios.get(`${process.env.REACT_APP_API_URL}api/v1/user/${username}/feed`, { headers: { 'x-auth-token': getToken()} }).then((res) => {
                // console.log(res.data);
                this.setState({ items: res.data.posts, pageNum: 1, followingUser: true, authorizationToken: res.data.authorizationToken || null });
            }).catch((err) => {
                console.log(err);
                if (err.response.data.msg === 'User not following') {
                    this.setState({followingUser: false})
                } else if (err.response.data.msg === 'No posts found') {
                    this.setState({ hasMore: false, followingUser: true });
                } else if (err.response.data.msg === 'Not Verified' || err.response.data.error === 'Missing Auth Token') {
                    forceLogout();
                }
            });
        }

        axios.post(`${process.env.REACT_APP_API_URL}api/v1/user/email`, null, { headers: { 'x-auth-token': getToken() } }).then((res) => {
            this.setState({ email: res.data.email });
        }).catch(err => {
            console.log(err);
        });

        axios.get(`${process.env.REACT_APP_API_URL}api/v1/payments/getAvailableMethods`, { headers: { 'x-auth-token': getToken() } }).then((res) => {
            this.setState({ paymentProviders: res.data.data });
        }).catch(err => {
            console.log(err);
        });
            // });
        // } else {
            // Redirect to login
            // window.location.href = '/login';
        // }
    }

    componentWillUnmount() {
        // Clean up polling interval
        if (this.state.purchasePollInterval) {
            clearInterval(this.state.purchasePollInterval);
        }
    }

    startPurchasePolling(purchaseID: string) {
        const interval = setInterval(() => {
            this.checkPurchaseStatus(purchaseID);
        }, 2500); // Poll every 2.5 seconds
        
        this.setState({ purchasePollInterval: interval });
        // Also check immediately
        this.checkPurchaseStatus(purchaseID);
    }

    stopPurchasePolling() {
        if (this.state.purchasePollInterval) {
            clearInterval(this.state.purchasePollInterval);
            this.setState({ purchasePollInterval: null });
        }
    }

    async checkPurchaseStatus(purchaseID: string) {
        const maxAttempts = 15; // 15 attempts * 2.5 seconds = ~37.5 seconds max
        
        if (this.state.purchasePollAttempts >= maxAttempts) {
            this.stopPurchasePolling();
            this.setState({ 
                authorizingPurchase: false,
                purchaseID: ''
            });
            toast.error('Purchase authorization timed out. Please refresh the page.', {
                style: {
                    color: '#ffffff',
                    backgroundColor: '#242C37',
                }
            });
            // Clean up URL
            const url = new URL(window.location.href);
            url.searchParams.delete('purchaseID');
            url.searchParams.delete('session_id');
            window.history.replaceState({}, '', url.toString());
            return;
        }

        try {
            const res = await axios.get(
                `${process.env.REACT_APP_API_URL}api/v1/stripe/purchaseStatus/${purchaseID}`,
                { headers: { 'x-auth-token': getToken() } }
            );

            if (res.data.confirmed === true) {
                // Purchase confirmed! Reload page to show updated feed
                this.stopPurchasePolling();
                
                // Clean up URL before reload
                const url = new URL(window.location.href);
                url.searchParams.delete('purchaseID');
                url.searchParams.delete('session_id');
                url.searchParams.set('purchased', 'true'); // Add purchased flag for feed refresh
                
                // Reload page to ensure fresh state and show purchased content
                window.location.href = url.toString();
            } else if (res.data.processing === true) {
                // Payment succeeded but webhook still processing - show processing message
                // Continue polling but don't increment attempts (we're waiting for webhook)
                console.log('Purchase payment succeeded, waiting for webhook processing...');
            } else {
                // Not confirmed yet, continue polling
                this.setState({ purchasePollAttempts: this.state.purchasePollAttempts + 1 });
            }
        } catch (err: any) {
            console.error('Error checking purchase status:', err);
            // On error, stop polling and show error
            this.stopPurchasePolling();
            this.setState({ 
                authorizingPurchase: false,
                purchaseID: ''
            });
            toast.error('Error checking purchase status. Please refresh the page.', {
                style: {
                    color: '#ffffff',
                    backgroundColor: '#242C37',
                }
            });
            // Clean up URL
            const url = new URL(window.location.href);
            url.searchParams.delete('purchaseID');
            url.searchParams.delete('session_id');
            window.history.replaceState({}, '', url.toString());
        }
    }

    async refetchUserFeed() {
        try {
            const username = this.state.username;
            const fromPostID = this.state.fromPostID;
            
            // Add purchased=true parameter to ensure backend properly detects purchased content
            // This helps with race conditions where ContentAccess might have just been created
            const purchasedParam = 'purchased=true';
            
            if (fromPostID !== null) {
                const res = await axios.get(
                    `${process.env.REACT_APP_API_URL}api/v1/user/${username}/feed?fromPost=${fromPostID}&${purchasedParam}`,
                    { headers: { 'x-auth-token': getToken()} }
                );
                // Ensure posts have required tax fields
                const posts = res.data.posts.map((post: any) => ({
                    ...post,
                    taxInclusivePrice: post.taxInclusivePrice ?? post.price,
                    taxIncluded: post.taxIncluded ?? false
                }));
                this.setState({ 
                    items: posts, 
                    pageNum: 1, 
                    followingUser: true,
                    authorizationToken: res.data.authorizationToken || null,
                });
            } else {
                const res = await axios.get(
                    `${process.env.REACT_APP_API_URL}api/v1/user/${username}/feed?${purchasedParam}`,
                    { headers: { 'x-auth-token': getToken()} }
                );
                // Ensure posts have required tax fields
                const posts = res.data.posts.map((post: any) => ({
                    ...post,
                    taxInclusivePrice: post.taxInclusivePrice ?? post.price,
                    taxIncluded: post.taxIncluded ?? false
                }));
                this.setState({ 
                    items: posts, 
                    pageNum: 1, 
                    followingUser: true,
                    authorizationToken: res.data.authorizationToken || null,
                });
            }
        } catch (err: any) {
            console.error('Error refetching user feed:', err);
        }
    }

    async authCodeInput(e: any) {
        // console.log(e.length);
        if (e.length === 6) {
            // Submit API request to verify code to CLERK
            // clerk.session?.getToken().then(async (token) => {
                await toast.promise(
                    axios.post(`${process.env.REACT_APP_API_URL}api/v1/user/2fa`, { code: e }, { headers: { 'x-auth-token': getToken(), 'Bearer': getBearer() }, withCredentials: true }).then((res) => {
                        if (res.data.msg === 'Code Verified') {
                            this.setState({ twoFacSuccess: true });
                        }
                    }), {
                        loading: 'Verifying ...',
                        success: 'Code Verified!',
                        error: 'Invalid Code!',
                    }, {
                        style: {
                            color: '#ffffff',
                            backgroundColor: '#242C37',
                        }
                    }
                )

                // const { data, error } = await authClient.twoFactor.verifyTotp({
                //     code: e,
                // });

                // console.log(data, error);
            // });
        }
    }

    toggleFollow() {
        // var token = localStorage.getItem('token');
        // clerk.session?.getToken().then(async (token) => {
            axios.post(`${process.env.REACT_APP_API_URL}api/v1/user/follow`, { username: this.state.username }, { headers: { 'x-auth-token': getToken() } }).then((res) => {
                // console.log(res.data);
                if (res.data.msg === 'Followed') {
                    // Should somehow update subscriptions list ... --- Sockets???
                    // Update Feed by executing Fetch Request...
                    this.setState({ following: true });
                } else {
                    // Should somehow update subscriptions list ... --- Sockets???
                    this.setState({ following: false });
                }
            }).catch(err => {
                // Use Toast Error System
                // console.error(err);
                if (err.response.data.msg === 'Not Verified') {
                    forceLogout();
                } else {
                    toast.error('An error has occurred!', { style: {
                        color: '#ffffff',
                        backgroundColor: '#242C37',
                    }});
                }
            });
        // });
    }

    async followUser() {
        await axios.get(`${process.env.REACT_APP_API_URL}api/v1/totp`, { headers: { 'x-auth-token': getToken() }}).then((res) => {
            // console.log(res.data);
            this.setState({ followModal: true, totpEnabled: res.data.totp, twoFacSuccess: res.data.twoFacSuccess, userSuspended: res.data.userSuspended });
        })
    }

    unfollowUser() {
        axios.get(`${process.env.REACT_APP_API_URL}api/v1/stripe/customerPortal`, { headers: { 'x-auth-token': getToken() } }).then(res => {
            window.open(res.data.url, '_blank');
        });
    }

    async fetchData() {
        if (!this.state.hasMore || this.state.loadingMore) return;

        const nextPage = this.state.pageNum + 1;
        this.setState({ loadingMore: true });

        const url = this.state.fromPostID !== null
            ? `${process.env.REACT_APP_API_URL}api/v1/user/${this.state.username}/feed?page=${nextPage}&fromPost=${this.state.fromPostID}`
            : `${process.env.REACT_APP_API_URL}api/v1/user/${this.state.username}/feed?page=${nextPage}`;

        axios.get(url, { headers: { 'x-auth-token': getToken() } }).then((res) => {
            if (res.data.posts && res.data.posts.length > 0) {
                this.setState(prevState => ({
                    items: [...prevState.items, ...res.data.posts],
                    pageNum: nextPage,
                    loadingMore: false,
                    followingUser: true,
                    verified: res.data.verified,
                    authorizationToken: res.data.authorizationToken || prevState.authorizationToken,
                }));
            } else {
                this.setState({ hasMore: false, loadingMore: false });
            }
        }).catch((err) => {
            console.log(err);
            this.setState({ loadingMore: false });
            if (err.response?.data?.msg === 'User not following') {
                this.setState({ followingUser: false });
            } else if (err.response?.data?.msg === 'No posts found') {
                this.setState({ hasMore: false });
            } else if (err.response?.data?.msg === 'Not Verified' || err.response?.data?.error === 'Missing Auth Token') {
                forceLogout();
            }
        });
    }

    toggleLike(e: any, postID: any) {
            axios.put(`${process.env.REACT_APP_API_URL}api/v1/post/${postID}/like`, null, { headers: { 'x-auth-token': getToken() } }).then((res) => {
                // var updatedItems = this.state.items.map((post) => {
                //     if (post.postID === postID) {
                //         post.likes = res.data.likes;
                //         post.isPostLiked = !post.isPostLiked;
                //     }
                //     return post;
                // });
                // this.setState({ items: updatedItems });
                const updatedItems = this.state.items.map((post) => {
                    if (post.postID === postID) {
                        return {
                            ...post,
                            likes: res.data.likes,
                            isPostLiked: !post.isPostLiked
                        };
                    }
                    return post;
                });

                this.setState({ items: updatedItems });
            }).catch((err) => {
                console.error(err);
                if (err.response.data.msg === 'Not Verified' || err.response.data.error === 'Missing Auth Token') {
                    forceLogout();
                } else {
                    toast.error('An error has occurred!', { style: {
                        color: '#ffffff',
                        backgroundColor: '#242C37',
                    }});
                }
            });
    }

    responsive = {
        superLargeDesktop: {
          // the naming can be any, depends on you.
          breakpoint: { max: 4000, min: 3000 },
          items: 5
        },
        desktop: {
          breakpoint: { max: 3000, min: 1024 },
          items: 3
        },
        tablet: {
          breakpoint: { max: 1024, min: 464 },
          items: 2
        },
        mobile: {
          breakpoint: { max: 464, min: 0 },
          items: 1
        }
    };

    async uploadBanner() {
        var fileInput = document.getElementById('profileBanner');
        if (fileInput) {
            fileInput.click();
            fileInput.addEventListener('change', async (e: any) => {
                const file = e.target.files[0];
                if (!file) return;

                try {
                    // Step 1: Get presigned URL
                    const presignedResponse = await axios.post(
                        `${process.env.REACT_APP_API_URL}api/v1/user/bannerPic/presigned`,
                        {
                            fileName: file.name,
                            contentType: file.type || 'image/jpeg',
                        },
                        { headers: { 'x-auth-token': getToken() } }
                    );

                    if (!presignedResponse.data.valid) {
                        throw new Error('Failed to get presigned URL');
                    }

                    const { presignedUrl, s3Key } = presignedResponse.data;

                    // Step 2: Upload directly to S3
                    await axios.put(presignedUrl, file, {
                        headers: {
                            'Content-Type': file.type || 'image/jpeg',
                        },
                    });

                    // Step 3: Complete upload by updating database
                    const completeResponse = await axios.post(
                        `${process.env.REACT_APP_API_URL}api/v1/user/bannerPic/complete`,
                        { s3Key },
                        { headers: { 'x-auth-token': getToken() } }
                    );

                    if (completeResponse.data.msg === 'Banner Updated') {
                        window.location.reload();
                    } else {
                        toast.error('An error has occurred!', {
                            style: {
                                color: '#ffffff',
                                backgroundColor: '#242C37',
                            },
                        });
                    }
                } catch (err: any) {
                    console.error(err);
                    toast.error('Failed to upload banner', {
                        style: {
                            color: '#ffffff',
                            backgroundColor: '#242C37',
                        },
                    });
                }
            });
        }
    }

    async uploadProfilePic() {
        var fileInput = document.getElementById('profilePicture');
        console.log(fileInput)
        if (fileInput) {
            fileInput.click();
            fileInput.addEventListener('change', async (e: any) => {
                const file = e.target.files[0];
                if (!file) return;

                try {
                    // Step 1: Get presigned URL
                    const presignedResponse = await axios.post(
                        `${process.env.REACT_APP_API_URL}api/v1/user/profilePic/presigned`,
                        {
                            fileName: file.name,
                            contentType: file.type || 'image/jpeg',
                        },
                        { headers: { 'x-auth-token': getToken() } }
                    );

                    if (!presignedResponse.data.valid) {
                        throw new Error('Failed to get presigned URL');
                    }

                    const { presignedUrl, s3Key } = presignedResponse.data;

                    // Step 2: Upload directly to S3
                    await axios.put(presignedUrl, file, {
                        headers: {
                            'Content-Type': file.type || 'image/jpeg',
                        },
                    });

                    // Step 3: Complete upload by updating database
                    const completeResponse = await axios.post(
                        `${process.env.REACT_APP_API_URL}api/v1/user/profilePic/complete`,
                        { s3Key },
                        { headers: { 'x-auth-token': getToken() } }
                    );

                    if (completeResponse.data.msg === 'Profile Picture Updated') {
                        window.location.reload();
                    } else {
                        toast.error('An error has occurred!', {
                            style: {
                                color: '#ffffff',
                                backgroundColor: '#242C37',
                            },
                        });
                    }
                } catch (err: any) {
                    console.error(err);
                    toast.error('Failed to upload profile picture', {
                        style: {
                            color: '#ffffff',
                            backgroundColor: '#242C37',
                        },
                    });
                }
            });
        }
    }

    closeProfileModal() {
        this.setState({ profileModalShown: false });
    }

    openEditModal() {
        this.setState({ profileModalShown: true });
    }

    async updateProfile() {
        // var token = localStorage.getItem('token');
        var displayName = this.displayNameInput.current?.value;
        var username = this.usernameInput.current?.value;

        // clerk.session?.getToken().then(async (token) => {
            await axios.post(`${process.env.REACT_APP_API_URL}api/v1/user/profile`, { displayName: displayName, username: username }, { headers: { 'x-auth-token': getToken() } }).then((res) => {
                // console.log(res.data);
                this.setState({ user: res.data.user });
                this.closeProfileModal();
                toast.success('Profile Updated!', { style: {
                    color: '#ffffff',
                    backgroundColor: '#242C37',
                }});
                window.location.href = `/app/user/${username}`;
            }).catch(err => {
                console.error(err);
                if (err.response.data.msg === 'Not Verified') {
                    forceLogout();
                } else if (err.response.data.msg === 'No changes made') {
                    toast.error('No changes made!', { style: {
                        color: '#ffffff',
                        backgroundColor: '#242C37',
                    }});
                } else {
                    toast.error('An error has occurred!', { style: {
                        color: '#ffffff',
                        backgroundColor: '#242C37',
                    }});
                }
            });
        // });
    }

    buy(postID: string, button: any, price: number, post: Post) {
        button.innerHTML = `Purchasing ...`;

        // clerk.session?.getToken().then(async (token) => {
            axios.get(`${process.env.REACT_APP_API_URL}api/v1/totp`, { headers: { 'x-auth-token': getToken() }}).then((res) => {
                console.log(res.data);
                this.setState({ purchaseShow: true, purchaseData: post, purchaseID: post.postID, totpEnabled: res.data.totp, twoFacSuccess: res.data.twoFacSuccess, userSuspended: res.data.userSuspended });
            })
        // });

        // this.setState({ purchaseShow: true, purchaseData: post, purchaseID: post.postID });

        // console.log(post);

        // Trigger Modal Open ... 


        // axios.post(`${process.env.REACT_APP_API_URL}api/v1/post/${postID}/buy`, null, { headers: { 'x-auth-token': token } }).then((res) => {
        //     toast.success('Post Purchased!', { style: {
        //         color: '#ffffff',
        //         backgroundColor: '#242C37',
        //     }});

        //     setTimeout(() => {
        //         button.innerHTML = `Purchased!`;
        //         window.location.reload();
        //     }, 2000)
        // }).catch(err => {
        //     toast.error(`An error has occurred! ${err.response.data.msg}`, { style: {
        //         color: '#ffffff',
        //         backgroundColor: '#242C37',
        //     }});
        // });
    }   

    inputChange(e: any) {
        // console.log(e);
        if (e.target.name === 'number') {
            this.setState({ number: formatCreditCardNumber(e.target.value) });
            e.target.value = formatCreditCardNumber(e.target.value);
            if (!isCardNumberValid(e.target.value)) {
                e.target.classList.add('ring-2');
                e.target.classList.add('ring-red-500');
            } else {
                e.target.classList.remove('ring-2');
                e.target.classList.remove('ring-red-500');
            }
            if (this.state.number === null || this.state.expiry === null || this.state.name === null || this.state.ccv === null) {
                if (this.payBTN.current !== null) {
                    this.payBTN.current.disabled = true;
                }
            } else {
                if (this.payBTN.current !== null) {
                    this.payBTN.current.disabled = false;
                }
            }
        } else if (e.target.name === 'expiry') {
            this.setState({ expiry: formatExpirationDate(e.target.value) });
            e.target.value = formatExpirationDate(e.target.value);
            if (!isCardExpiryValid(e.target.value)) {
                // e.target.style.color = 'red';
                e.target.classList.add('ring-2');
                e.target.classList.add('ring-red-500');
            } else {
                e.target.classList.remove('ring-2');
                e.target.classList.remove('ring-red-500');
            }
            if (this.state.number === null || this.state.expiry === null || this.state.name === null || this.state.ccv === null) {
                if (this.payBTN.current !== null) {
                    this.payBTN.current.disabled = true;
                }
            } else {
                if (this.payBTN.current !== null) {
                    this.payBTN.current.disabled = false;
                }
            }
        } else if (e.target.name === 'name') {
            this.setState({ name: e.target.value });
            if (this.state.number === null || this.state.expiry === null || this.state.name === null || this.state.ccv === null) {
                if (this.payBTN.current !== null) {
                    this.payBTN.current.disabled = true;
                }
            } else {
                if (this.payBTN.current !== null) {
                    this.payBTN.current.disabled = false;
                }
            }
        } else if (e.target.name === 'cvc') {
            // @ts-ignore
            this.setState({ ccv: formatCVC(e.target.value) });
            // @ts-ignore
            e.target.value = formatCVC(e.target.value);
            if (!isCardCVCValid(e.target.value)) {
                e.target.classList.add('ring-2');
                e.target.classList.add('ring-red-500');
            } else {
                e.target.classList.remove('ring-2');
                e.target.classList.remove('ring-red-500');
            }

            if (this.state.number === null || this.state.expiry === null || this.state.name === null || this.state.ccv === null) {
                if (this.payBTN.current !== null) {
                    this.payBTN.current.disabled = true;
                }
            } else {
                if (this.payBTN.current !== null) {
                    this.payBTN.current.disabled = false;
                }
            }
        }

    }

    closePaymentModal() {
        if (this.state.isPaymentActive === true) {
            return; // Do not close modal if payment is active
        } else {
            var paymentID = this.state.purchaseID;
            var elem = document.getElementById(`buy-${paymentID}`);
            if (elem) {
                // Gotta get payamount.
                if (this.state.purchaseData !== null) {
                    var amount = this.state.purchaseData?.price + (this.state.purchaseData?.price * 0.15);
                    elem.innerHTML = `Pay - $${amount?.toFixed(2)} USD`;
                }
            }
            // Close modal
            this.setState({ purchaseShow: false, purchaseID: '', cardFocused: '' });
        }
    }

    closeCommentModal() {
        // this.setState({ commentModal: false, activePostID: null, commentData: null });
        this.setState({ commentModal: false, activePostID: null, commentData: null, openCommentMenuIndex: null });
    }

    openCommentModal(postID: string) {
        // Fetch comments for post ... 
        // clerk.session?.getToken().then(async (token) => {
            axios.get(`${process.env.REACT_APP_API_URL}api/v1/comments/${postID}`, { headers: { 'x-auth-token': getToken() } }).then((res) => {
                console.log(res.data);
                this.setState({ comments: res.data.comments });
            }).catch(err => {
                console.log(err);
            });
        // });


        this.setState({ commentModal: true, activePostID: postID });
    }

    // setNewDisplayName(value: any) {
    //     // @ts-ignore
    //     this.setState({ user: { displayName: value } });
    // } 

    // setNewUsername(value: any) {
    //     // @ts-ignore
    //     this.setState({ user: { username: value } });
    // }

    loadStripeComponent() {
        // @ts-ignore
        return loadStripe(process.env.REACT_APP_STRIPE_KEY);
    }

    checkoutSession(postID: any) {
        // console.log(postID);
        var secret = '';
        const fetchSession = async () => {
            const session = await axios.post(`${process.env.REACT_APP_API_URL}api/v1/stripe/checkoutSession/${postID}`, {}, { headers: { 'x-auth-token': getToken() } }).then((res) => {
                return res.data.session;
            }).catch(err => {
                console.log(err);
            });
            return session.client_secret;
        }

        return { clientSecret: secret, fetchClientSecret: fetchSession }
    }

    subscriptionSession(planID: any) {
        var secret = '';
        const fetchSession = async () => {
            const session = await axios.post(`${process.env.REACT_APP_API_URL}api/v1/stripe/subscriptionCheckout/${planID}`, {}, { headers: { 'x-auth-token': getToken() } }).then((res) => {
                return res.data.session;
            }).catch(err => {
                console.log(err);
            });
            return session.client_secret;
        }

        return {
            clientSecret: secret,
            fetchClientSecret: fetchSession,
            onComplete: () => {
                this.setState({ followModal: false });
                window.location.reload();
            }
        }
    }

    submitComment(e: any) {
        e.preventDefault();

        if (this.state.activePostID === null) {
            return;
        } else {
            var comment = this.state.commentData;
            if (comment === null) {
                // Toast Error
                toast.error('Comment cannot be empty!', { style: {
                    color: '#ffffff',
                    backgroundColor: '#242C37',
                }});
            } else {
                // Submit api request ...
                // clerk.session?.getToken().then(async (token) => {
                    axios.post(`${process.env.REACT_APP_API_URL}api/v1/comments/${this.state.activePostID}`, { comment: comment }, { headers: { 'x-auth-token': getToken() }}).then((res) => {
                        // Handle comment submission response ...
                        if (res.data.msg === 'Comment Added') {
                            if(this.commentInput.current !== null) {
                                this.commentInput.current.value = '';
                            }

                            // Update comments count
                            const updatedItems = this.state.items.map((post) => {
                                if (post.postID === this.state.activePostID) {
                                    return {
                                        ...post,
                                        comments: post.comments + 1
                                    };
                                }
                                return post;
                            });

                            this.setState(prevState => ({ comments: [res.data.comment, ...(prevState.comments || [])], items: updatedItems }));
                        } else if (res.data.userBanned === true) {
                            toast.error('User is banned, no comments submitted!', { style: {
                                color: '#ffffff',
                                backgroundColor: '#242C37',
                            }});
                        }
                    }).catch(err => {
                        console.log(err);
                    });
            }
        }
    }

    renderHeader = () => {
        return (
            <div id="profile" className="bg-gray-700 w-full my-3 pb-4 rounded-md">
                {(() => {
                    if (this.state.isSelf) {
                        // @ts-ignore
                        if (this.state.user.bannerPic === null || !this.state.user.bannerPic || this.state.user.bannerPic === '') {
                            return <>
                                <input type="file" className="hidden" name="profileBanner" id="profileBanner" accept="image/png, image/jpeg" />
                                <div onClick={() => this.uploadBanner()} className="bg-red-600 h-60 w-full rounded-t-md hover:cursor-pointer"></div>
                            </>
                        } else {
                            return <>
                                <input type="file" className="hidden" name="profileBanner" id="profileBanner" accept="image/png, image/jpeg" />
                                {/* @ts-ignore */}
                                <img alt="Upload a banner" title="Upload a banner" src={this.state.user.bannerPic} onClick={() => this.uploadBanner()} className="w-full h-60 rounded-t-md object-cover hover:cursor-pointer" />
                            </>
                        }
                    } else {
                        // @ts-ignore
                        if (this.state.user.bannerPic=== null || !this.state.user.bannerPic || this.state.user.bannerPic === '') {
                            return <div className="bg-red-600 h-60 w-full rounded-t-md"></div>
                        } else {
                            // @ts-ignore
                            return <img src={this.state.user.bannerPic} className="w-full h-60 rounded-t-md object-cover" />
                        }
                    }
                })()}

                {/* <div className="bg-red-600 h-60 w-full rounded-t-md"></div> */}
                <div className="flex items-center h-full w-full px-4 pt-4">
                    {(() => {
                        if (this.state.isSelf) {
                            // @ts-ignore
                            if (this.state.user.profilePic === null || this.state.user.profilePic === undefined || !this.state.user.profilePic) {
                                if (this.state.isLive) {
                                    return <>
                                        <input type="file" className="hidden" name="profilePicture" id="profilePicture" accept="image/png, image/jpeg" />
                                        <a href={window.location.href + '/live'}><img alt="Upload a banner" title="Upload a profile picture" onClick={() => this.uploadProfilePic()} src={ProfilePic} className="h-14 w-14 rounded-full cursor-pointer ring-2 ring-red-500" /></a>
                                        {/* <div onClick={() => this.uploadProfilePic()} className="bg-red-600 h-14 w-14 rounded-full cursor-pointer"></div> */}
                                    </>
                                } else {
                                    return <>
                                        <input type="file" className="hidden" name="profilePicture" id="profilePicture" accept="image/png, image/jpeg" />
                                        <img alt="Upload a banner" title="Upload a profile picture" onClick={() => this.uploadProfilePic()} src={ProfilePic} className="h-14 w-14 rounded-full cursor-pointer" />
                                        {/* <div onClick={() => this.uploadProfilePic()} className="bg-red-600 h-14 w-14 rounded-full cursor-pointer"></div> */}
                                    </>
                                }
                                // return <span className="h-14 w-14 rounded-full bg-red-600"></span>
                            } else {
                                if (this.state.isLive) {
                                    return <>
                                        <input type="file" className="hidden" name="profilePicture" id="profilePicture" accept="image/png, image/jpeg" />
                                        {/* @ts-ignore */}
                                        {/* <img alt="Upload a profile picture" title="Upload a profile picture" onClick={() => this.uploadProfilePic()} src={`${process.env.REACT_APP_API_URL}api/v1/user/${this.state.user.username}/profilePic`} className="h-14 w-14 rounded-full cursor-pointer" /> */}
                                        {/* @ts-ignore */}
                                        <img alt="Upload a profile picture" title="Upload a profile picture" onClick={() => this.uploadProfilePic()} src={this.state.user.profilePic} className="h-14 w-14 rounded-full cursor-pointer" />
                                    </>
                                } else {
                                    return <>
                                        <input type="file" className="hidden" name="profilePicture" id="profilePicture" accept="image/png, image/jpeg" />
                                        {/* @ts-ignore */}
                                        {/* <img alt="Upload a profile picture" title="Upload a profile picture" onClick={() => this.uploadProfilePic()} src={`${process.env.REACT_APP_API_URL}api/v1/user/${this.state.user.username}/profilePic`} className="h-14 w-14 rounded-full cursor-pointer" /> */}
                                        {/* @ts-ignore */}
                                        <img alt="Upload a profile picture" title="Upload a profile picture" onClick={() => this.uploadProfilePic()} src={this.state.user.profilePic} className="h-14 w-14 rounded-full cursor-pointer" />
                                    </>
                                }
                            }
                        } else {
                            // @ts-ignore
                            if (this.state.user.profilePic === null || this.state.user.profilePic === undefined || !this.state.user.profilePic) {
                                // return <span className="h-14 w-14 rounded-full bg-red-600"></span>
                                if (this.state.isLive && this.state.followingUser === true) {
                                    return <a href={window.location.href + '/live'}><img src={ProfilePic} className="5-14 w-14 rounded-full" /></a>
                                } else {
                                    return <img src={ProfilePic} className="5-14 w-14 rounded-full" />
                                }
                            } else {
                                // @ts-ignore
                                // return <img src={this.state.user.profilePic} className="h-14 w-14 rounded-full" />
                                // return <img src={`${process.env.REACT_APP_API_URL}api/v1/user/${this.state.user.username}/profilePic`} className="h-14 w-14 rounded-full" />
                                if (this.state.isLive && this.state.followingUser === true) {
                                    // @ts-ignore
                                    return <a href={window.location.href + '/live'}><img src={this.state.user.profilePic} className="h-14 w-14 rounded-full ring-2 ring-red-500" /></a>
                                } else {
                                    // @ts-ignore
                                    return <img src={this.state.user.profilePic} className="h-14 w-14 rounded-full" />
                                }
                            }
                        }
                    })()}
                    {/* <span className="h-14 w-14 rounded-full bg-red-600"></span> */}
                    {(() => {
                            if (this.state.isSelf) {
                                // @ts-ignore
                                if (this.state.user.verified) {
                                    return <div className="ml-4">
                                        {/* @ts-ignore */}
                                        <h3 onClick={(() => this.openEditModal())} className="text-white text-xl font-bold hover:cursor-pointer">
                                            <div className="inline-flex">
                                                <i className="fa-solid fa-badge-check text-sky-500" title="Verified Creator" />
                                                {/* @ts-ignore */}
                                                <div className="pl-2">{this.state.user.displayName}</div>
                                            </div>
                                        </h3>
                                        <p className="text-gray-300 text-base">{this.formatFollowers(this.state.followers)}</p>
                                        {/* <p onClick={(() => this.openEditModal())} className="text-gray-300 text-xl hover:cursor-pointer">@{this.state.username}</p> */}
                                    </div>
                                } else {
                                    {/* @ts-ignore */}
                                    return <div className="ml-4">
                                        {/* @ts-ignore */}
                                        <h3 onClick={(() => this.openEditModal())} className="text-white text-xl font-bold hover:cursor-pointer"> {this.state.user.displayName} <i className="fa-regular fa-pencil text-gray-300 px-1 text-sm" title="Edit" /></h3>
                                        <p  onClick={(() => this.openEditModal())} className="text-gray-300 text-xl hover:cursor-pointer">@{this.state.username}</p>
                                    </div>
                                }
                            } else {
                                // @ts-ignore
                                if (this.state.user.verified) {
                                    if (this.state.isLive && this.state.followingUser === true) {
                                        return <div className="ml-4">
                                            <h3 className="text-white text-xl font-bold">
                                            <i className="fa-solid fa-badge-check text-sky-500 pr-2" title="Verified Creator" />
                                            {/* @ts-ignore */}
                                            {this.state.user.displayName}
                                            <span className="bg-red-500 text-white px-2 py-1 ml-2 rounded-md text-sm animate-pulse">LIVE</span></h3>
                                            <p className="text-gray-300 text-xl">@{this.state.username}</p>
                                        </div>
                                    } else {
                                        return <div className="ml-4">
                                            <h3 className="text-white text-xl font-bold">
                                            <i className="fa-solid fa-badge-check text-sky-500 pr-2" title="Verified Creator" />
                                            {/* @ts-ignore */}
                                            {this.state.user.displayName}</h3>
                                            <p className="text-gray-300 text-xl">@{this.state.username}</p>
                                        </div>
                                    }
                                } else {
                                    {/* @ts-ignore */}
                                    return <div className="ml-4">
                                        {/* @ts-ignore */}
                                        <h3 className="text-white text-xl font-bold"> {this.state.user.displayName}</h3>
                                        <p className="text-gray-300 text-xl">@{this.state.username}</p>
                                    </div>
                                }
                            }
                        })()}
                    {/* <div className="ml-4">                        
                        <h3 className="text-white text-xl font-bold"><i className="fa-solid fa-badge-check text-sky-500" title="Verified Creator" /> {this.state.user.displayName}</h3>
                        <p className="text-gray-300 text-xl">@{this.state.username}</p>
                    </div> */}
                    <div className="flex-grow"></div>
                    <div className="flex items-end">
                        {(() => {
                            if (this.state.isSelf) {
                                // return <Link to={`${process.env.REACT_APP_URL}manage/creator`} className="bg-white text-black text-base font-bold rounded-md px-4 py-1">Manage Creator Account</Link>
                                return <span onClick={(() => this.openEditModal())} className="bg-white text-black text-base font-bold rounded-md px-4 py-1 hover:cursor-pointer">Manage</span>
                            } else {
                                console.log(this.state.isTaxInclusive);
                                console.log(this.state.taxInclusivePrice);
                                if (!this.state.following) {
                                    if (this.state.isTaxInclusive) {
                                        return <button onClick={() => this.followUser()} className="bg-red-600 text-white text-base font-bold rounded-md px-4 py-1">Follow ${this.state.taxInclusivePrice.toFixed(2)} USD</button>
                                    } else {
                                        return <button onClick={() => this.followUser()} className="bg-red-600 text-white text-base font-bold rounded-md px-4 py-1">Follow ${this.state.creatorSubPrice.toFixed(2)} USD</button>
                                    }
                                    // return <button onClick={() => this.followUser()} className="bg-red-600 text-white text-base font-bold rounded-md px-4 py-1">Follow ${this.state.creatorSubPrice}</button>
                                } else {
                                    return <button onClick={() => this.unfollowUser()} className="bg-white text-black text-base font-bold rounded-md px-4 py-1">Manage Subscription</button>
                                }
                            }
                        })()}
                    </div>
                </div>
            </div>
        )
    }

    toggleMenu = (postID: string) => {
        this.setState(prevState => ({
            openMenuPostID: prevState.openMenuPostID === postID ? null : postID,
        }));
    };

    handleEdit = (postID: string, title: string, desc: string) => {
        console.log('Editing post:', postID);
        this.setState({ editModal: true, editTitle: title, editDesc: desc, editPostID: postID, openMenuPostID: null });
    };

    closeEditModal = () => {
        this.setState({ editModal: false, editTitle: '', editDesc: '', editPostID: '' });
    }
    
    handleDelete = (postID: string, title: string) => {
        console.log('Deleting post:', postID);
        this.setState({ takedownModal: true, takedownPostID: postID, takedownTitle: title, openMenuPostID: null });
    };
    
    handleReport = (postID: string) => {
        console.log('Reporting post:', postID);

        // console.log(this.reportModalDescription);
        // if (this.reportModalDescription.current) {
        //     this.reportModalDescription.current.setAttribute('value', `PostID: ${postID}\n\nReason:\n`);
        //     // this.reportModalDescription.current.value = `PostID: ${postID}\n\nReason:\n`;
        // }
        this.setState({ openMenuPostID: null, reportModal: true, reportPost: postID, reportModalDescription: `PostID: ${postID}\nReason: ` });
    };

    closeModal = (modalType: string) => {
        if (modalType === 'report') {
            this.setState({ reportModal: false });
        } else if (modalType === 'edit') {
            this.setState({ editModal: false });
        } else if (modalType === 'takedown') {
            this.setState({ takedownModal: false });
        }
    }

    toggleCommentMenu = (index: number) => {
        this.setState((prevState) => ({
            openCommentMenuIndex: prevState.openCommentMenuIndex === index ? null : index,
        }));
    };

    banUserFromComments = (username: string) => {
        // axios
        //     .post(
        //         `${process.env.REACT_APP_API_URL}api/v1/users/ban/${username}`,
        //         {},
        //         { headers: { 'x-auth-token': getToken() } }
        //     )
        //     .then(() => {
        //         toast.success('User banned successfully');
        //         this.setState({ openCommentMenuIndex: null });
        //     })
        //     .catch(() => toast.error('Failed to ban user'));
    };

    renderItem = (index: number, post: Post) => {
        return (
            <div id="post" key={`${post.postID}`} className="bg-gray-700 w-ful my-4 rounded-md py-4 px-4">
                {/* <div className="absolute top-4 right-4 text-white">
                    <div className="relative inline-block text-left">
                        <button onClick={() => this.toggleMenu(post.postID)}>
                        <i className="fa-solid fa-ellipsis-vertical text-xl hover:text-gray-300"></i>
                        </button>

                        {this.state.openMenuPostID === post.postID && (
                        <div className="absolute right-0 mt-2 w-40 z-50 bg-gray-800 rounded-md shadow-lg py-2 border border-gray-700">
                            <button className="block w-full text-left px-4 py-2 text-white hover:bg-gray-700" onClick={() => this.handleEdit(post.postID)}>Edit</button>
                            <button className="block w-full text-left px-4 py-2 text-white hover:bg-gray-700" onClick={() => this.handleDelete(post.postID)}>Delete</button>
                            <button className="block w-full text-left px-4 py-2 text-white hover:bg-gray-700" onClick={() => this.handleReport(post.postID)}>Report Post</button>
                        </div>
                        )}
                    </div>
                </div> */}

                <div className="flex items-center justify-between w-full">
                    <div className="flex items-center">
                        {(() => {
                            if (post.isLive) {
                                if (post.profilePic === null || post.profilePic === undefined) {
                                    // return <span className="h-14 w-14 rounded-full bg-red-600 ring-2 ring-red-500"></span>
                                    return <img src={ProfilePic} className="h-14 w-14 rounded-full ring-2 ring-red-500" />
                                } else {
                                    // return <img src={post.profilePic} className="h-14 w-14 rounded-full" />
                                    return <a href={window.location.href + '/live'}><img src={post.profilePic} className="h-14 w-14 rounded-full ring-2 ring-red-500" /></a>
                                }
                            } else {
                                if (post.profilePic === null || post.profilePic === undefined) {
                                    // return <span className="h-14 w-14 rounded-full bg-red-600"></span>
                                    return <img src={ProfilePic} className="h-14 w-14 rounded-full" />
                                } else {
                                    // return <img src={post.profilePic} className="h-14 w-14 rounded-full" />
                                    return <img src={post.profilePic} className="h-14 w-14 rounded-full" />
                                }
                            }
                        })()}
                        <div className="ml-4">
                            <h3 className="text-white font-bold">
                                {/* @ts-ignore */}
                                <i className="fa-solid fa-badge-check text-sky-500" title="Verified Creator" /> {this.state.user.displayName}
                            </h3>
                            <p className="text-gray-300">{this.formatFollowers(post.followers)}</p>
                        </div>
                    </div>

                    <div className="relative">
                        <button onClick={() => this.toggleMenu(post.postID)} className="text-gray-500 px-2 py-2 hover:text-white rounded-md hover:bg-gray-800 focus:outline-none">
                            <i className="fa-solid fa-ellipsis-vertical text-xl"></i>
                        </button>

                        {this.state.openMenuPostID === post.postID && (
                            (() => {
                                if (this.state.isSelf) {
                                return (
                                    <div className="absolute right-0 mt-2 w-44 z-50 bg-gray-800 rounded-md shadow-lg py-2 border border-gray-700">
                                    <button
                                        className="block w-full text-left px-4 py-2 text-white hover:bg-gray-700"
                                        onClick={() => this.handleEdit(post.postID, post.title, post.description)}
                                    >
                                        <i className="fa-solid fa-pencil text-md text-gray-600"></i> Edit
                                    </button>
                                    <button
                                        className="block w-full text-left px-4 py-2 text-white hover:bg-gray-700"
                                        onClick={() => this.handleDelete(post.postID, post.title)}
                                    >
                                        <i className="fa-solid fa-trash text-md text-gray-600"></i> Takedown Post
                                    </button>
                                    <button
                                        className="block w-full text-left px-4 py-2 text-red-500 hover:bg-gray-700"
                                        onClick={() => this.handleReport(post.postID)}
                                    >
                                        <i className="fa-solid fa-flag text-md text-gray-600"></i> Report Post
                                    </button>
                                    </div>
                                );
                                } else {
                                return (
                                    <div className="absolute right-0 mt-2 w-44 z-50 bg-gray-800 rounded-md shadow-lg py-2 border border-gray-700">
                                    <button
                                        className="block w-full text-left px-4 py-2 text-red-500 hover:bg-gray-700"
                                        onClick={() => this.handleReport(post.postID)}
                                    >
                                        <i className="fa-solid fa-flag text-md text-gray-600"></i> Report Post
                                    </button>
                                    </div>
                                );
                                }
                            })()
                        )}
                    </div>
                </div>

                {/* <div className="flex items-center h-full w-full">
                    {(() => {
                        if (post.isLive) {
                            if (post.profilePic === null || post.profilePic === undefined) {
                                // return <span className="h-14 w-14 rounded-full bg-red-600 ring-2 ring-red-500"></span>
                                return <img src={ProfilePic} className="h-14 w-14 rounded-full ring-2 ring-red-500" />
                            } else {
                                // return <img src={post.profilePic} className="h-14 w-14 rounded-full" />
                                return <a href={window.location.href + '/live'}><img src={post.profilePic} className="h-14 w-14 rounded-full ring-2 ring-red-500" /></a>
                            }
                        } else {
                            if (post.profilePic === null || post.profilePic === undefined) {
                                // return <span className="h-14 w-14 rounded-full bg-red-600"></span>
                                return <img src={ProfilePic} className="h-14 w-14 rounded-full" />
                            } else {
                                // return <img src={post.profilePic} className="h-14 w-14 rounded-full" />
                                return <img src={post.profilePic} className="h-14 w-14 rounded-full" />
                            }
                        }
                    })()}
                    <div className="ml-4">
                        
                        <h3 className="text-white font-bold"><i className="fa-solid fa-badge-check text-sky-500" title="Verified Creator" /> {this.state.user.displayName}</h3>
                        <p className="text-gray-300">{this.formatFollowers(post.followers)}</p>
                    </div>
                </div> */}
                
                <div className="mt-4 px-2">
                    <h1 className="text-2xl font-bold pb-4">
                        {post.isHidden ? (
                            <i className="fa-solid fa-eye-slash text-md text-red-500 mr-2"></i>
                            ) : null}
                        {post.title}
                    </h1>
                </div>

                <div id="description">
                    <p className="text-white text-lg px-2">{post.description}</p>
                </div>

                <div id="media" className="h-128 mt-4">
                    {(() => {
                        if (post.access === true) {
                            return <div className="flex justify-center px-2">
                                <div className="flex gap-4 w-full"
                                    style={{
                                        maxHeight: '600px',
                                        maxWidth: '100%',
                                        // aspectRatio: '16 / 9',
                                        // backgroundColor: '#000',
                                        borderRadius: '12px',
                                        overflow: 'hidden',
                                        margin: '0 auto',
                                    }}
                                >
                                    {(() => {
                                        if (post.content) {
                                            if (post.content.length > 1) {
                                                return <Carousel showThumbs={false}>
                                                    {post.content.map((content: any, index: any) => (
                                                        <div><ShakaPlayerComponent name={this.state.myName} wmanifestURI={content.widevineURL} fmanifestURI={content.fairplayURL} type={content.type} contentID={content.id} ogname={content.filename} contentWidth={content.contentWidth} contentHeight={content.contentHeight} prevAccessed={content.prevAccessed} authorizationToken={this.state.authorizationToken || undefined} /></div>
                                                    ))}
                                                </Carousel>
                                            } else {
                                                return <ShakaPlayerComponent name={this.state.myName} wmanifestURI={post.content[0].widevineURL} fmanifestURI={post.content[0].fairplayURL} type={post.content[0].type} contentID={post.content[0].id} ogname={post.content[0].filename} contentWidth={post.content[0].contentWidth} contentHeight={post.content[0].contentHeight} prevAccessed={post.content[0].prevAccessed} authorizationToken={this.state.authorizationToken || undefined} />
                                            }
                                        }   
                                    })()}
                                </div>
                            </div>
                        } else {
                            return <div className="flex">
                                {/* Unlock content */}
                                <div className="flex grid grid-rows-6 bg-gray-800 w-full h-96 rounded-md flex items-center justify-center">
                                    <div></div> 
                                    <div className="text-white text-2xl row-span-4">Please purchase to unlock this post!</div>
                                    <button onClick={(e) => this.buy(post.postID, e.target, post.price, post)} id={`buy-${post.postID}`} className="flex bg-gray-900 text-white rounded-md px-2 py-1 justify-center hover:shadow-md hover:-translate-y-1 transition ease-in-out">Pay - ${post.price} USD (excl tax)</button>
                                </div>
                            </div>
                        }
                    })()}
                </div>

                <div id="postControls">
                    <div className="flex gap-4 px-2 pt-4 text-lg">
                        <span key={`${post.postID}-${post.isPostLiked}`} className="text-white">
                            {(() => {
                                if (post.access === true) {
                                    if (post.isPostLiked) {
                                        return <>
                                            <i className="fa-solid fa-heart text-red-500 hover:cursor-pointer" onClick={(e) => this.toggleLike(e, post.postID)}></i>
                                            <span className="ml-2">{this.formatLikes(post.likes)}</span>
                                            <span className="text-white hover:cursor-pointer ml-2" onClick={() => this.openCommentModal(post.postID)}>
                                                <i className="fa-regular fa-comment hover:cursor-pointer"></i>
                                                <span className="ml-2 hover:cursor-pointer">{this.formatComments(post.comments)}</span>
                                            </span>
                                        </>
                                    } else {
                                        return <>
                                            <i className="fa-regular fa-heart hover:cursor-pointer" onClick={(e) => this.toggleLike(e, post.postID)}></i>
                                            <span className="ml-2">{this.formatLikes(post.likes)}</span>
                                            <span className="text-white hover:cursor-pointer ml-2" onClick={() => this.openCommentModal(post.postID)}>
                                                <i className="fa-regular fa-comment hover:cursor-pointer"></i>
                                                <span className="ml-2 hover:cursor-pointer">{this.formatComments(post.comments)}</span>
                                            </span>
                                        </>
                                    }
                                } else {
                                    return <>
                                        <i className="fa-regular fa-heart" onClick={(() => {
                                            toast.error('Purchase to like the post!', { style: {
                                                color: '#ffffff',
                                                backgroundColor: '#242C37',
                                            }});
                                        })}></i>
                                        <span className="ml-2" onClick={(() => {
                                            toast.error('Purchase to like the post!', { style: {
                                                color: '#ffffff',
                                                backgroundColor: '#242C37',
                                            }});
                                        })}>{this.formatLikes(post.likes)}</span>
                                    </>
                                }
                            })()}
                        </span>
                    </div>
                </div>
            </div>
        )
    }

    formatFollowers(followers: number) {
        if (followers > 999 && followers < 1000000) {
            return (followers / 1000).toFixed(1) + 'K Followers';
        } else if (followers > 999999) {
            return (followers / 1000000).toFixed(1) + 'M Followers';
        } else if (followers === 1) {
            return followers + ' Follower';
        } else {
            return followers + ' Followers';
        }
    }

    formatLikes(likes: number) {
        if (likes > 999 && likes < 1000000) {
            return (likes / 1000).toFixed(1) + 'K Likes';
        } else if (likes > 999999) {
            return (likes / 1000000).toFixed(1) + 'M Likes';
        } else if (likes === 1) {
            return likes + ' Like';
        } else if (likes === 0) {
            return 'Like';
        } else {
            return likes + ' Likes';
        }
    }

    formatComments(comments: number | undefined) {
        if (comments === undefined) {
            return '0 Comments';
        } else {
            if (comments > 999 && comments < 1000000) {
                return (comments / 1000).toFixed(1) + 'K Comments';
            } else if (comments > 999999) {
                return (comments / 1000000).toFixed(1) + 'M Comments';
            } else if (comments === 1) {
                return comments + ' Comment';
            } else if (comments === 0) {
                return '0 Comments';
            } else {
                return comments + ' Comments';
            }
        }
    }

    async commentBanUser(userID: string, contentID: string) {
        // Ban User
        await axios.post(`${process.env.REACT_APP_API_URL}api/v1/ban/${userID}`, { contentID: contentID }, { headers: { 'x-auth-token': getToken() } }).then((res) => {
            if (res.data.msg === 'User Banned') {
                toast.success('User banned successfully', { style: {
                    color: '#ffffff',
                    backgroundColor: '#242C37',
                }});
                this.setState({ openCommentMenuIndex: null });
            } else if (res.data.userBanned === true) {
                toast.error('User is already banned!', { style: {
                    color: '#ffffff',
                    backgroundColor: '#242C37',
                }});
            }
        }).catch(err => {
            console.log(err);
            toast.error('Failed to ban user', { style: {
                color: '#ffffff',
                backgroundColor: '#242C37',
            }});
        })
    }

    reportForm(value: any, type: string) {
        if (type === 'title') {
            this.setState({title: value});
            if (this.state.title !== null && this.state.category !== null && this.state.desc !== null) {
                if (this.reportSubmit.current !== null) {
                    this.reportSubmit.current.disabled = false;
                }
            }
        } else if (type === 'category') {
            this.setState({category: value});
            if (this.state.title !== null && this.state.category !== null && this.state.desc !== null) {
                if (this.reportSubmit.current !== null) {
                    this.reportSubmit.current.disabled = false;
                }
            }
        } else if (type === 'desc') {
            this.setState({desc: value});
            if (this.state.title !== null && this.state.category !== null && this.state.desc !== null) {
                if (this.reportSubmit.current !== null) {
                    this.reportSubmit.current.disabled = false;
                }
            }
        }
    }

    editForm(value: any, type: string) {
        if (type === 'title') {
            this.setState({ editTitle: value });
        } else if (type === 'desc') {
            this.setState({ editDesc: value });
        }
    }

    async submitReport(e: any) {
        console.log(`Submitting report for postID: ${this.state.reportPost}`);

        e.preventDefault();

        console.log(this.state.title, this.state.category, this.state.desc);
        
        await axios.post(`${process.env.REACT_APP_API_URL}api/v1/report/general`, {
            postID: this.state.reportPost,
            title: this.state.title,
            category: this.state.category,
            desc: this.state.desc
        }, { headers: { 'x-auth-token': getToken() } }).then(res => {
            if (res.data.msg === 'Success') {
                toast.success('Report submitted successfully', { style: {
                    color: '#ffffff',
                    backgroundColor: '#242C37',
                }});
                this.setState({ reportModal: false, reportPost: '', title: '', category: '', desc: '' });
            } else {
                toast.error('Failed to submit report', { style: {
                    color: '#ffffff',
                    backgroundColor: '#242C37',
                }});
                this.setState({ reportModal: false, reportPost: '', title: '', category: '', desc: '' });
            }
        }).catch(err => {
            console.log(err);
            toast.error('Failed to submit report', { style: {
                color: '#ffffff',
                backgroundColor: '#242C37',
            }});
            this.setState({ reportModal: false, reportPost: '', title: '', category: '', desc: '' });
        });
    }

    async submitEdit(e: any) {
        console.log(`Submitting edit for postID: ${this.state.editPostID}`);
        e.preventDefault();
        await axios.post(`${process.env.REACT_APP_API_URL}api/v1/edit/post`, {
            postID: this.state.editPostID,
            title: this.state.editTitle,
            description: this.state.editDesc
        }, { headers: { 'x-auth-token': getToken() } }).then(res => {
            if (res.data.msg === 'Post Updated') {
                toast.success('Post updated successfully', { style: {
                    color: '#ffffff',
                    backgroundColor: '#242C37',
                }});
                this.setState({ editModal: false, editPostID: '', editTitle: '', editDesc: '' });
                window.location.reload();
                // this.getPosts();
            } else {
                toast.error('Failed to update post', { style: {
                    color: '#ffffff',
                    backgroundColor: '#242C37',
                }});
                this.setState({ editModal: false, editPostID: '', editTitle: '', editDesc: '' });
                window.location.reload();
                // this.getPosts();
            }
        }).catch(err => {
            console.log(err);
            toast.error('Failed to update post', { style: {
                color: '#ffffff',
                backgroundColor: '#242C37',
            }});
            this.setState({ editModal: false, editPostID: '', editTitle: '', editDesc: '' });
        });
    }

    async takedownPost(e: any) {
        console.log(`Submitting takedown for postID: ${this.state.takedownPostID}`);
        e.preventDefault();
        await axios.post(`${process.env.REACT_APP_API_URL}api/v1/takedown/post`, {
            postID: this.state.takedownPostID
        }, { headers: { 'x-auth-token': getToken() } }).then(res => {
            if (res.data.msg === 'Post Taken Down') {
                toast.success('Takedown request submitted successfully', { style: {
                    color: '#ffffff',
                    backgroundColor: '#242C37',
                }});
                this.setState({ takedownModal: false, editPostID: '' });
                window.location.reload();
            } else {
                toast.error('Failed to submit takedown request', { style: {
                    color: '#ffffff',
                    backgroundColor: '#242C37',
                }});
                this.setState({ takedownModal: false, editPostID: '' });
                window.location.reload();
            }
        }).catch(err => {
            console.log(err);
            toast.error('Failed to submit takedown request', { style: {
                color: '#ffffff',
                backgroundColor: '#242C37',
            }});
            this.setState({ takedownModal: false, editPostID: '' });
        });
    }

    render() {
        function formatFollowers(followers: number) {
            if (followers > 999 && followers < 1000000) {
                return (followers / 1000).toFixed(1) + 'K Followers';
            } else if (followers > 999999) {
                return (followers / 1000000).toFixed(1) + 'M Followers';
            } else if (followers === 1) {
                return followers + ' Follower';
            } else {
                return followers + ' Followers';
            }
        }

        function formatLikes(likes: number) {
            if (likes > 999 && likes < 1000000) {
                return (likes / 1000).toFixed(1) + 'K Likes';
            } else if (likes > 999999) {
                return (likes / 1000000).toFixed(1) + 'M Likes';
            } else if (likes === 1) {
                return likes + ' Like';
            } else if (likes === 0) {
                return 'Like';
            } else {
                return likes + ' Likes';
            }
        }

        function formatComments(comments: number | undefined) {
            if (comments === undefined) {
                return '0 Comments';
            } else {
                if (comments > 999 && comments < 1000000) {
                    return (comments / 1000).toFixed(1) + 'K Comments';
                } else if (comments > 999999) {
                    return (comments / 1000000).toFixed(1) + 'M Comments';
                } else if (comments === 1) {
                    return comments + ' Comment';
                } else if (comments === 0) {
                    return '0 Comments';
                } else {
                    return comments + ' Comments';
                }
            }
        }

        function commentDateFormat(date: string) {
            // Given date, format to 'mins ago' 'days ago' 'weeks ago' 'years ago'
            var currentDate = new Date();
            var commentDate = new Date(date);
            var diff = currentDate.getTime() - commentDate.getTime();
            var seconds = diff / 1000;
            var minutes = seconds / 60;
            var hours = minutes / 60;

            if (seconds < 60) {
                return 'Just Now';
            } else if (minutes < 60) {
                return Math.floor(minutes) + 'm ago';
            } else if (hours < 24) {
                return Math.floor(hours) + 'h ago';
            } else if (hours < 48) {
                return 'Yesterday';
            } else if (hours < 168) {
                return Math.floor(hours / 24) + 'd ago';
            } else if (hours < 8760) {
                return Math.floor(hours / 168) + 'w ago';
            } else {
                return Math.floor(hours / 8760) + 'y ago';
            }
        }

        // const target = document.querySelectorAll('#post');

        // const observer = new IntersectionObserver((entries) => {
        //     entries.forEach(entry => {
        //         if (entry.isIntersecting) {
        //             // @ts-ignore
        //             const postID = entry.target.getAttribute('x-postID');
        //             // @ts-ignore
        //             const url = new URL(window.location);
        //             // @ts-ignore
        //             url.searchParams.set('postID', postID);
        //             window.history.pushState({}, '', url);
        //         }
        //     })
        // });

        // target.forEach(t => {
        //     console.log('d')
        //     observer.observe(t);
        // })

        return <div className="col-span-2 h-full">
            <Toaster position="bottom-center" />
            
            {/* Authorization Modal */}
            <Transition appear show={this.state.authorizingPurchase}>
                <Dialog className="relative z-50" onClose={() => {}}>
                    <TransitionChild
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
                    </TransitionChild>
                    <div className="fixed inset-0 flex items-center justify-center p-4">
                        <TransitionChild
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <DialogPanel className="mx-auto max-w-sm rounded-lg bg-gray-800 p-6 text-white">
                                <DialogTitle className="text-lg font-semibold mb-4 text-center">
                                    {this.state.purchasePollAttempts > 0 && this.state.purchasePollAttempts < 3 
                                        ? 'Processing purchase...' 
                                        : 'Authorizing content...'}
                                </DialogTitle>
                                <div className="flex flex-col items-center justify-center py-4">
                                    <MoonLoader color="#ffffff" size={40} />
                                    <p className="mt-4 text-sm text-gray-300 text-center">
                                        {this.state.purchasePollAttempts > 0 && this.state.purchasePollAttempts < 3
                                            ? 'Payment successful! Confirming your purchase...'
                                            : 'Please wait while we confirm your purchase.'}
                                    </p>
                                </div>
                            </DialogPanel>
                        </TransitionChild>
                    </div>
                </Dialog>
            </Transition>
            
            {/* Mock profile page ... */}
            
            {/* Display Profile Feed */}
            {(() => {
                if (this.state.loading === false && this.state.followingUser === false) {
                    return <div className="bg-gray-700 w-full my-4 px-4 py-4 rounded-md">
                        <div id="profile" className="bg-gray-700 w-full my-3 pb-4 rounded-md">
                            {(() => {
                                if (this.state.isSelf) {
                                    // @ts-ignore
                                    if (this.state.user.bannerPic === null || !this.state.user.bannerPic || this.state.user.bannerPic === '') {
                                        return <>
                                            <input type="file" className="hidden" name="profileBanner" id="profileBanner" accept="image/png, image/jpeg" />
                                            <div onClick={() => this.uploadBanner()} className="bg-red-600 h-60 w-full rounded-t-md hover:cursor-pointer"></div>
                                        </>
                                    } else {
                                        return <>
                                            <input type="file" className="hidden" name="profileBanner" id="profileBanner" accept="image/png, image/jpeg" />
                                            {/* @ts-ignore */}
                                            <img alt="Upload a banner" title="Upload a banner" src={this.state.user.bannerPic} onClick={() => this.uploadBanner()} className="w-full h-60 rounded-t-md object-cover hover:cursor-pointer" />
                                        </>
                                    }
                                } else {
                                    // @ts-ignore
                                    if (this.state.user.bannerPic=== null || !this.state.user.bannerPic || this.state.user.bannerPic === '') {
                                        return <div className="bg-red-600 h-60 w-full rounded-t-md"></div>
                                    } else {
                                        // @ts-ignore
                                        return <img src={this.state.user.bannerPic} className="w-full h-60 rounded-t-md object-cover" />
                                    }
                                }
                            })()}

                            {/* <div className="bg-red-600 h-60 w-full rounded-t-md"></div> */}
                            <div className="flex items-center h-full w-full px-4 pt-4">
                                {(() => {
                                    if (this.state.isSelf) {
                                        // @ts-ignore
                                        if (this.state.user.profilePic === null || this.state.user.profilePic === undefined || !this.state.user.profilePic) {
                                            if (this.state.isLive) {
                                                return <>
                                                    <input type="file" className="hidden" name="profilePicture" id="profilePicture" accept="image/png, image/jpeg" />
                                                    <a href={window.location.href + '/live'}><img alt="Upload a banner" title="Upload a profile picture" onClick={() => this.uploadProfilePic()} src={ProfilePic} className="h-14 w-14 rounded-full cursor-pointer ring-2 ring-red-500" /></a>
                                                    {/* <div onClick={() => this.uploadProfilePic()} className="bg-red-600 h-14 w-14 rounded-full cursor-pointer"></div> */}
                                                </>
                                            } else {
                                                return <>
                                                    <input type="file" className="hidden" name="profilePicture" id="profilePicture" accept="image/png, image/jpeg" />
                                                    <img alt="Upload a banner" title="Upload a profile picture" onClick={() => this.uploadProfilePic()} src={ProfilePic} className="h-14 w-14 rounded-full cursor-pointer" />
                                                    {/* <div onClick={() => this.uploadProfilePic()} className="bg-red-600 h-14 w-14 rounded-full cursor-pointer"></div> */}
                                                </>
                                            }
                                            // return <span className="h-14 w-14 rounded-full bg-red-600"></span>
                                        } else {
                                            if (this.state.isLive) {
                                                return <>
                                                    <input type="file" className="hidden" name="profilePicture" id="profilePicture" accept="image/png, image/jpeg" />
                                                    {/* @ts-ignore */}
                                                    {/* <img alt="Upload a profile picture" title="Upload a profile picture" onClick={() => this.uploadProfilePic()} src={`${process.env.REACT_APP_API_URL}api/v1/user/${this.state.user.username}/profilePic`} className="h-14 w-14 rounded-full cursor-pointer" /> */}
                                                    {/* @ts-ignore */}
                                                    <img alt="Upload a profile picture" title="Upload a profile picture" onClick={() => this.uploadProfilePic()} src={this.state.user.profilePic} className="h-14 w-14 rounded-full cursor-pointer" />
                                                </>
                                            } else {
                                                return <>
                                                    <input type="file" className="hidden" name="profilePicture" id="profilePicture" accept="image/png, image/jpeg" />
                                                    {/* @ts-ignore */}
                                                    {/* <img alt="Upload a profile picture" title="Upload a profile picture" onClick={() => this.uploadProfilePic()} src={`${process.env.REACT_APP_API_URL}api/v1/user/${this.state.user.username}/profilePic`} className="h-14 w-14 rounded-full cursor-pointer" /> */}
                                                    {/* @ts-ignore */}
                                                    <img alt="Upload a profile picture" title="Upload a profile picture" onClick={() => this.uploadProfilePic()} src={this.state.user.profilePic} className="h-14 w-14 rounded-full cursor-pointer" />
                                                </>
                                            }
                                        }
                                    } else {
                                        // @ts-ignore
                                        if (this.state.user.profilePic === null || this.state.user.profilePic === undefined || !this.state.user.profilePic) {
                                            // return <span className="h-14 w-14 rounded-full bg-red-600"></span>
                                            if (this.state.isLive && !!this.state.followingUser) {
                                                return <a href={window.location.href + '/live'}><img src={ProfilePic} className="5-14 w-14 rounded-full" /></a>
                                            } else {
                                                return <img src={ProfilePic} className="5-14 w-14 rounded-full" />
                                            }
                                        } else {
                                            // @ts-ignore
                                            // return <img src={this.state.user.profilePic} className="h-14 w-14 rounded-full" />
                                            // return <img src={`${process.env.REACT_APP_API_URL}api/v1/user/${this.state.user.username}/profilePic`} className="h-14 w-14 rounded-full" />
                                            if (this.state.isLive && this.state.followingUser === true) {
                                                // @ts-ignore
                                                return <a href={window.location.href + '/live'}><img src={this.state.user.profilePic} className="h-14 w-14 rounded-full ring-2 ring-red-500" /></a>
                                            } else {
                                                // @ts-ignore
                                                return <img src={this.state.user.profilePic} className="h-14 w-14 rounded-full" />
                                            }
                                        }
                                    }
                                })()}
                                {/* <span className="h-14 w-14 rounded-full bg-red-600"></span> */}
                                {(() => {
                                        if (this.state.isSelf) {
                                            // @ts-ignore
                                            if (this.state.user.verified) {
                                                return <div className="ml-4">
                                                    {/* @ts-ignore */}
                                                    <h3 onClick={(() => this.openEditModal())} className="text-white text-xl font-bold hover:cursor-pointer">
                                                        <div className="inline-flex">
                                                            <i className="fa-solid fa-badge-check text-sky-500" title="Verified Creator" />
                                                            {/* @ts-ignore */}
                                                            <div className="pl-2">{this.state.user.displayName}</div>
                                                        </div>
                                                    </h3>
                                                    <p className="text-gray-300 text-base">{this.formatFollowers(this.state.followers)}</p>
                                                    {/* <p onClick={(() => this.openEditModal())} className="text-gray-300 text-xl hover:cursor-pointer">@{this.state.username}</p> */}
                                                </div>
                                            } else {
                                                {/* @ts-ignore */}
                                                return <div className="ml-4">
                                                    {/* @ts-ignore */}
                                                    <h3 onClick={(() => this.openEditModal())} className="text-white text-xl font-bold hover:cursor-pointer"> {this.state.user.displayName} <i className="fa-regular fa-pencil text-gray-300 px-1 text-sm" title="Edit" /></h3>
                                                    <p  onClick={(() => this.openEditModal())} className="text-gray-300 text-xl hover:cursor-pointer">@{this.state.username}</p>
                                                </div>
                                            }
                                        } else {
                                            // @ts-ignore
                                            if (this.state.user.verified) {
                                                if (this.state.isLive && !!this.state.followingUser) {
                                                    return <div className="ml-4">
                                                        <h3 className="text-white text-xl font-bold">
                                                        <i className="fa-solid fa-badge-check text-sky-500 pr-2" title="Verified Creator" />
                                                        {/* @ts-ignore */}
                                                        {this.state.user.displayName}
                                                        <span className="bg-red-500 text-white px-2 py-1 ml-2 rounded-md text-sm animate-pulse">LIVE</span></h3>
                                                        <p className="text-gray-300 text-xl">@{this.state.username}</p>
                                                    </div>
                                                } else {
                                                    return <div className="ml-4">
                                                        <h3 className="text-white text-xl font-bold">
                                                        <i className="fa-solid fa-badge-check text-sky-500 pr-2" title="Verified Creator" />
                                                        {/* @ts-ignore */}
                                                        {this.state.user.displayName}</h3>
                                                        <p className="text-gray-300 text-xl">@{this.state.username}</p>
                                                    </div>
                                                }
                                            } else {
                                                {/* @ts-ignore */}
                                                return <div className="ml-4">
                                                    {/* @ts-ignore */}
                                                    <h3 className="text-white text-xl font-bold"> {this.state.user.displayName}</h3>
                                                    <p className="text-gray-300 text-xl">@{this.state.username}</p>
                                                </div>
                                            }
                                        }
                                    })()}
                                {/* <div className="ml-4">                        
                                    <h3 className="text-white text-xl font-bold"><i className="fa-solid fa-badge-check text-sky-500" title="Verified Creator" /> {this.state.user.displayName}</h3>
                                    <p className="text-gray-300 text-xl">@{this.state.username}</p>
                                </div> */}
                                <div className="flex-grow"></div>
                                <div className="flex items-end">
                                    {(() => {
                                        if (this.state.isSelf) {
                                            // return <Link to={`${process.env.REACT_APP_URL}manage/creator`} className="bg-white text-black text-base font-bold rounded-md px-4 py-1">Manage Creator Account</Link>
                                            return <span onClick={(() => this.openEditModal())} className="bg-white text-black text-base font-bold rounded-md px-4 py-1 hover:cursor-pointer">Manage</span>
                                        } else {
                                            console.log(this.state.isTaxInclusive);
                                            console.log(this.state.taxInclusivePrice);
                                            if (!this.state.following) {
                                                if (this.state.isTaxInclusive) {
                                                    return <button onClick={() => this.followUser()} className="bg-red-600 text-white text-base font-bold rounded-md px-4 py-1">Follow ${this.state.taxInclusivePrice.toFixed(2)} USD</button>
                                                } else {
                                                    return <button onClick={() => this.followUser()} className="bg-red-600 text-white text-base font-bold rounded-md px-4 py-1">Follow ${this.state.creatorSubPrice.toFixed(2)} USD</button>
                                                }
                                                // return <button onClick={() => this.followUser()} className="bg-red-600 text-white text-base font-bold rounded-md px-4 py-1">Follow ${this.state.creatorSubPrice}</button>
                                            } else {
                                                return <button onClick={() => this.unfollowUser()} className="bg-white text-black text-base font-bold rounded-md px-4 py-1">Manage Subscription</button>
                                            }
                                        }
                                    })()}
                                </div>
                            </div>
                        </div>
                        <h1 className="text-lg font-bold text-center">Follow this creator to see their posts!</h1>
                    </div>
                } else if (this.state.loading === false && this.state.items.length === 0) {
                    return <div className="bg-gray-700 w-full my-4 px-4 py-4 rounded-md">
                        <div id="profile" className="bg-gray-700 w-full my-3 pb-4 rounded-md">
                            {(() => {
                                if (this.state.isSelf) {
                                    // @ts-ignore
                                    if (this.state.user.bannerPic === null || !this.state.user.bannerPic || this.state.user.bannerPic === '') {
                                        return <>
                                            <input type="file" className="hidden" name="profileBanner" id="profileBanner" accept="image/png, image/jpeg" />
                                            <div onClick={() => this.uploadBanner()} className="bg-red-600 h-60 w-full rounded-t-md hover:cursor-pointer"></div>
                                        </>
                                    } else {
                                        return <>
                                            <input type="file" className="hidden" name="profileBanner" id="profileBanner" accept="image/png, image/jpeg" />
                                            {/* @ts-ignore */}
                                            <img alt="Upload a banner" title="Upload a banner" src={this.state.user.bannerPic} onClick={() => this.uploadBanner()} className="w-full h-60 rounded-t-md object-cover hover:cursor-pointer" />
                                        </>
                                    }
                                } else {
                                    // @ts-ignore
                                    if (this.state.user.bannerPic=== null || !this.state.user.bannerPic || this.state.user.bannerPic === '') {
                                        return <div className="bg-red-600 h-60 w-full rounded-t-md"></div>
                                    } else {
                                        // @ts-ignore
                                        return <img src={this.state.user.bannerPic} className="w-full h-60 rounded-t-md object-cover" />
                                    }
                                }
                            })()}

                            {/* <div className="bg-red-600 h-60 w-full rounded-t-md"></div> */}
                            <div className="flex items-center h-full w-full px-4 pt-4">
                                {(() => {
                                    if (this.state.isSelf) {
                                        // @ts-ignore
                                        if (this.state.user.profilePic === null || this.state.user.profilePic === undefined || !this.state.user.profilePic) {
                                            if (this.state.isLive) {
                                                return <>
                                                    <input type="file" className="hidden" name="profilePicture" id="profilePicture" accept="image/png, image/jpeg" />
                                                    <a href={window.location.href + '/live'}><img alt="Upload a banner" title="Upload a profile picture" onClick={() => this.uploadProfilePic()} src={ProfilePic} className="h-14 w-14 rounded-full cursor-pointer ring-2 ring-red-500" /></a>
                                                    {/* <div onClick={() => this.uploadProfilePic()} className="bg-red-600 h-14 w-14 rounded-full cursor-pointer"></div> */}
                                                </>
                                            } else {
                                                return <>
                                                    <input type="file" className="hidden" name="profilePicture" id="profilePicture" accept="image/png, image/jpeg" />
                                                    <img alt="Upload a banner" title="Upload a profile picture" onClick={() => this.uploadProfilePic()} src={ProfilePic} className="h-14 w-14 rounded-full cursor-pointer" />
                                                    {/* <div onClick={() => this.uploadProfilePic()} className="bg-red-600 h-14 w-14 rounded-full cursor-pointer"></div> */}
                                                </>
                                            }
                                            // return <span className="h-14 w-14 rounded-full bg-red-600"></span>
                                        } else {
                                            if (this.state.isLive) {
                                                return <>
                                                    <input type="file" className="hidden" name="profilePicture" id="profilePicture" accept="image/png, image/jpeg" />
                                                    {/* @ts-ignore */}
                                                    {/* <img alt="Upload a profile picture" title="Upload a profile picture" onClick={() => this.uploadProfilePic()} src={`${process.env.REACT_APP_API_URL}api/v1/user/${this.state.user.username}/profilePic`} className="h-14 w-14 rounded-full cursor-pointer" /> */}
                                                    {/* @ts-ignore */}
                                                    <img alt="Upload a profile picture" title="Upload a profile picture" onClick={() => this.uploadProfilePic()} src={this.state.user.profilePic} className="h-14 w-14 rounded-full cursor-pointer" />
                                                </>
                                            } else {
                                                return <>
                                                    <input type="file" className="hidden" name="profilePicture" id="profilePicture" accept="image/png, image/jpeg" />
                                                    {/* @ts-ignore */}
                                                    {/* <img alt="Upload a profile picture" title="Upload a profile picture" onClick={() => this.uploadProfilePic()} src={`${process.env.REACT_APP_API_URL}api/v1/user/${this.state.user.username}/profilePic`} className="h-14 w-14 rounded-full cursor-pointer" /> */}
                                                    {/* @ts-ignore */}
                                                    <img alt="Upload a profile picture" title="Upload a profile picture" onClick={() => this.uploadProfilePic()} src={this.state.user.profilePic} className="h-14 w-14 rounded-full cursor-pointer" />
                                                </>
                                            }
                                        }
                                    } else {
                                        // @ts-ignore
                                        if (this.state.user.profilePic === null || this.state.user.profilePic === undefined || !this.state.user.profilePic) {
                                            // return <span className="h-14 w-14 rounded-full bg-red-600"></span>
                                            if (this.state.isLive && !!this.state.followingUser) {
                                                return <a href={window.location.href + '/live'}><img src={ProfilePic} className="5-14 w-14 rounded-full" /></a>
                                            } else {
                                                return <img src={ProfilePic} className="5-14 w-14 rounded-full" />
                                            }
                                        } else {
                                            // @ts-ignore
                                            // return <img src={this.state.user.profilePic} className="h-14 w-14 rounded-full" />
                                            // return <img src={`${process.env.REACT_APP_API_URL}api/v1/user/${this.state.user.username}/profilePic`} className="h-14 w-14 rounded-full" />
                                            if (this.state.isLive && this.state.followingUser === true) {
                                                // @ts-ignore
                                                return <a href={window.location.href + '/live'}><img src={this.state.user.profilePic} className="h-14 w-14 rounded-full ring-2 ring-red-500" /></a>
                                            } else {
                                                // @ts-ignore
                                                return <img src={this.state.user.profilePic} className="h-14 w-14 rounded-full" />
                                            }
                                        }
                                    }
                                })()}
                                {/* <span className="h-14 w-14 rounded-full bg-red-600"></span> */}
                                {(() => {
                                        if (this.state.isSelf) {
                                            // @ts-ignore
                                            if (this.state.user.verified) {
                                                return <div className="ml-4">
                                                    {/* @ts-ignore */}
                                                    <h3 onClick={(() => this.openEditModal())} className="text-white text-xl font-bold hover:cursor-pointer">
                                                        <div className="inline-flex">
                                                            <i className="fa-solid fa-badge-check text-sky-500" title="Verified Creator" />
                                                            {/* @ts-ignore */}
                                                            <div className="pl-2">{this.state.user.displayName}</div>
                                                        </div>
                                                    </h3>
                                                    <p className="text-gray-300 text-base">{this.formatFollowers(this.state.followers)}</p>
                                                    {/* <p onClick={(() => this.openEditModal())} className="text-gray-300 text-xl hover:cursor-pointer">@{this.state.username}</p> */}
                                                </div>
                                            } else {
                                                {/* @ts-ignore */}
                                                return <div className="ml-4">
                                                    {/* @ts-ignore */}
                                                    <h3 onClick={(() => this.openEditModal())} className="text-white text-xl font-bold hover:cursor-pointer"> {this.state.user.displayName} <i className="fa-regular fa-pencil text-gray-300 px-1 text-sm" title="Edit" /></h3>
                                                    <p  onClick={(() => this.openEditModal())} className="text-gray-300 text-xl hover:cursor-pointer">@{this.state.username}</p>
                                                </div>
                                            }
                                        } else {
                                            // @ts-ignore
                                            if (this.state.user.verified) {
                                                if (this.state.isLive && !!this.state.followingUser) {
                                                    return <div className="ml-4">
                                                        <h3 className="text-white text-xl font-bold">
                                                        <i className="fa-solid fa-badge-check text-sky-500 pr-2" title="Verified Creator" />
                                                        {/* @ts-ignore */}
                                                        {this.state.user.displayName}
                                                        <span className="bg-red-500 text-white px-2 py-1 ml-2 rounded-md text-sm animate-pulse">LIVE</span></h3>
                                                        <p className="text-gray-300 text-xl">@{this.state.username}</p>
                                                    </div>
                                                } else {
                                                    return <div className="ml-4">
                                                        <h3 className="text-white text-xl font-bold">
                                                        <i className="fa-solid fa-badge-check text-sky-500 pr-2" title="Verified Creator" />
                                                        {/* @ts-ignore */}
                                                        {this.state.user.displayName}</h3>
                                                        <p className="text-gray-300 text-xl">@{this.state.username}</p>
                                                    </div>
                                                }
                                            } else {
                                                {/* @ts-ignore */}
                                                return <div className="ml-4">
                                                    {/* @ts-ignore */}
                                                    <h3 className="text-white text-xl font-bold"> {this.state.user.displayName}</h3>
                                                    <p className="text-gray-300 text-xl">@{this.state.username}</p>
                                                </div>
                                            }
                                        }
                                    })()}
                                {/* <div className="ml-4">                        
                                    <h3 className="text-white text-xl font-bold"><i className="fa-solid fa-badge-check text-sky-500" title="Verified Creator" /> {this.state.user.displayName}</h3>
                                    <p className="text-gray-300 text-xl">@{this.state.username}</p>
                                </div> */}
                                <div className="flex-grow"></div>
                                <div className="flex items-end">
                                    {(() => {
                                        if (this.state.isSelf) {
                                            // return <Link to={`${process.env.REACT_APP_URL}manage/creator`} className="bg-white text-black text-base font-bold rounded-md px-4 py-1">Manage Creator Account</Link>
                                            return <span onClick={(() => this.openEditModal())} className="bg-white text-black text-base font-bold rounded-md px-4 py-1 hover:cursor-pointer">Manage</span>
                                        } else {
                                            console.log(this.state.isTaxInclusive);
                                            console.log(this.state.taxInclusivePrice);
                                            if (!this.state.following) {
                                                if (this.state.isTaxInclusive) {
                                                    return <button onClick={() => this.followUser()} className="bg-red-600 text-white text-base font-bold rounded-md px-4 py-1">Follow ${this.state.taxInclusivePrice.toFixed(2)} USD</button>
                                                } else {
                                                    return <button onClick={() => this.followUser()} className="bg-red-600 text-white text-base font-bold rounded-md px-4 py-1">Follow ${this.state.creatorSubPrice.toFixed(2)} USD</button>
                                                }
                                                // return <button onClick={() => this.followUser()} className="bg-red-600 text-white text-base font-bold rounded-md px-4 py-1">Follow ${this.state.creatorSubPrice}</button>
                                            } else {
                                                return <button onClick={() => this.unfollowUser()} className="bg-white text-black text-base font-bold rounded-md px-4 py-1">Manage Subscription</button>
                                            }
                                        }
                                    })()}
                                </div>
                            </div>
                        </div>
                        {/* if user isnt following, show to follow else show the message bellow */}
                        {(() => {
                            if (!this.state.following) {
                                return <h1 className="text-lg font-bold text-center">Follow this creator to see their posts!</h1>
                            } else {
                                return <h1 className="text-lg font-bold text-center">No posts available! Check back later when this creator makes a post!</h1>
                            }
                        })()}
                        {/* <h1 className="text-lg font-bold text-center">No posts available! Check back later when this creator makes a post!</h1> */}
                    </div>
                } else if (this.state.loading === false && this.state.items.length !== 0) {
                    // return <Virtuoso 
                    //     style={{ height: '90vh' }} 
                        
                    //     totalCount={this.state.items.length} 
                    //     data={this.state.items}
                    //     itemContent={(index, post) => this.renderItem(index, post)}
                    //     computeItemKey={(index, post) => post.postID}
                    //     // itemContent={this.renderItem} 
                    //     defaultItemHeight={510}
                    //     increaseViewportBy={{ top: 1000, bottom: 1000 }}
                    //     followOutput={true}
                    //     className="scrollFeed mr-4"
                    //     components={{ Header: this.renderHeader }}
                    // />

                    return <FeedComponent items={this.state.items} header={true} creator={this.state.user} creatorSubPrice={this.state.creatorSubPrice} planID={this.state.planID} following={this.state.following} followingUser={this.state.followingUser} isSelf={this.state.isSelf} isTaxInclusive={this.state.isTaxInclusive} taxIncludedPrice={this.state.taxInclusivePrice} onLoadMore={this.fetchData} hasMore={this.state.hasMore} authorizationToken={this.state.authorizationToken || undefined} />
                    
                    // return <InfiniteScroll 
                    //     dataLength={this.state.items.length}
                    //     next={this.fetchData}
                    //     hasMore={this.state.hasMore}
                    //     loader={
                    //         <div>
                    //             <div className="bg-gray-700 w-full my-4 rounded-md">
                    //                 <div className="flex animate-pulse items-center h-full px-4 py-4">
                    //                     <span className="min-h-10 min-w-10 rounded-full bg-slate-700"></span>
                    //                     <div className="ml-4 w-full">
                    //                         <div className="h-2 w-1/4 bg-slate-700 rounded"></div>
                    //                         <div className="h-2 w-1/12 mt-2 bg-slate-700 rounded"></div>
                    //                     </div>
                    //                 </div>
                    //                 <div className="animate-pulse px-4 py-4">
                    //                     <div className="h-2 mt-2 w-full bg-slate-700 rounded"></div>
                    //                     <div className="h-2 mt-2 w-full bg-slate-700 rounded"></div>
                    //                     <div className="h-2 mt-2 w-full bg-slate-700 rounded"></div>
                    //                     <div className="h-2 mt-2 w-full bg-slate-700 rounded"></div>
                    //                 </div>
                    //             </div>
                    //             <div className="bg-gray-700 w-full my-4 rounded-md">
                    //                 <div className="flex animate-pulse items-center h-full px-4 py-4">
                    //                     <span className="min-h-10 min-w-10 rounded-full bg-slate-700"></span>
                    //                     <div className="ml-4 w-full">
                    //                         <div className="h-2 w-1/4 bg-slate-700 rounded"></div>
                    //                         <div className="h-2 w-1/12 mt-2 bg-slate-700 rounded"></div>
                    //                     </div>
                    //                 </div>
                    //                 <div className="animate-pulse px-4 py-4">
                    //                     <div className="h-2 mt-2 w-full bg-slate-700 rounded"></div>
                    //                     <div className="h-2 mt-2 w-full bg-slate-700 rounded"></div>
                    //                     <div className="h-2 mt-2 w-full bg-slate-700 rounded"></div>
                    //                     <div className="h-2 mt-2 w-full bg-slate-700 rounded"></div>
                    //                 </div>
                    //             </div>
                    //             <div className="bg-gray-700 w-full my-4 rounded-md">
                    //                 <div className="flex animate-pulse items-center h-full px-4 py-4">
                    //                     <span className="min-h-10 min-w-10 rounded-full bg-slate-700"></span>
                    //                     <div className="ml-4 w-full">
                    //                         <div className="h-2 w-1/4 bg-slate-700 rounded"></div>
                    //                         <div className="h-2 w-1/12 mt-2 bg-slate-700 rounded"></div>
                    //                     </div>
                    //                 </div>
                    //                 <div className="animate-pulse px-4 py-4">
                    //                     <div className="h-2 mt-2 w-full bg-slate-700 rounded"></div>
                    //                     <div className="h-2 mt-2 w-full bg-slate-700 rounded"></div>
                    //                     <div className="h-2 mt-2 w-full bg-slate-700 rounded"></div>
                    //                     <div className="h-2 mt-2 w-full bg-slate-700 rounded"></div>
                    //                 </div>
                    //             </div>
                    //         </div>
                    //     }
                    //     scrollableTarget="scrollableDiv"
                    //     >
                    //         {(() => {
                    //             if (Array.isArray(this.state.items)) {
                    //                 return this.state.items.map((post, index) => (
                    //                     <div id="post" x-postID={post.postID} className="bg-gray-700 w-full my-4 rounded-md py-4 px-4">
                    //                         <div className="flex items-center h-full w-full">
                    //                             {(() => {
                    //                                 if (post.isLive) {
                    //                                     if (post.profilePic === null || post.profilePic === undefined) {
                    //                                         // return <span className="h-14 w-14 rounded-full bg-red-600 ring-2 ring-red-500"></span>
                    //                                         return <img src={ProfilePic} className="h-14 w-14 rounded-full ring-2 ring-red-500" />
                    //                                     } else {
                    //                                         // return <img src={post.profilePic} className="h-14 w-14 rounded-full" />
                    //                                         return <a href={window.location.href + '/live'}><img src={post.profilePic} className="h-14 w-14 rounded-full ring-2 ring-red-500" /></a>
                    //                                     }
                    //                                 } else {
                    //                                     if (post.profilePic === null || post.profilePic === undefined) {
                    //                                         // return <span className="h-14 w-14 rounded-full bg-red-600"></span>
                    //                                         return <img src={ProfilePic} className="h-14 w-14 rounded-full" />
                    //                                     } else {
                    //                                         // return <img src={post.profilePic} className="h-14 w-14 rounded-full" />
                    //                                         return <img src={post.profilePic} className="h-14 w-14 rounded-full" />
                    //                                     }
                    //                                 }
                    //                             })()}
                    //                             <div className="ml-4">
                    //                                 <h3 className="text-white font-bold"><i className="fa-solid fa-badge-check text-sky-500" title="Verified Creator" /> {this.state.user.displayName}</h3>
                    //                                 <p className="text-gray-300">{formatFollowers(post.followers)}</p>
                    //                             </div>
                    //                         </div>
                    //                         <div className="mt-4 px-2">
                    //                             <h1 className="text-2xl font-bold pb-4">{post.title}ddd</h1>
                    //                         </div>

                    //                         <div id="description">
                    //                             <p className="text-white text-lg px-2">{post.description}</p>
                    //                         </div>
                        
                    //                         <div id="media" className="mt-4">
                    //                             {(() => {
                    //                                 if (post.access === true) {
                    //                                     return <div className="flex justify-center px-2">
                    //                                         <div className="flex gap-4">
                    //                                             {(() => {
                    //                                                 if (post.content) {
                    //                                                     if (post.content.length > 1) {
                    //                                                         return <Carousel>
                    //                                                             {post.content.map((content: any, index: any) => (
                    //                                                                 <div className="pb-10"><ShakaPlayerComponent name={this.state.myName} wmanifestURI={content.widevineURL} fmanifestURI={content.fairplayURL} type={content.type} contentID={content.id} ogname={content.filename} contentWidth={content.contentWidth} contentHeight={content.contentHeight} /></div>
                    //                                                             ))}
                    //                                                         </Carousel>
                    //                                                     } else {
                    //                                                         return <ShakaPlayerComponent name={this.state.myName} wmanifestURI={post.content[0].widevineURL} fmanifestURI={post.content[0].fairplayURL} type={post.content[0].type} contentID={post.content[0].id} ogname={post.content[0].filename} contentWidth={post.content[0].contentWidth} contentHeight={post.content[0].contentHeight} />
                    //                                                     }
                    //                                                 }   
                    //                                             })()}
                    //                                         </div>
                    //                                     </div>
                    //                                 } else {
                    //                                     return <div className="flex">
                    //                                         <div className="flex grid grid-rows-6 bg-gray-800 w-full h-96 rounded-md flex items-center justify-center">
                    //                                             <div></div> 
                    //                                             <div className="text-white text-2xl row-span-4">Please purchase to unlock this post!</div>
                    //                                             <button onClick={(e) => this.buy(post.postID, e.target, post.price, post)} id={`buy-${post.postID}`} className="flex bg-gray-900 text-white rounded-md px-2 py-1 justify-center hover:shadow-md hover:-translate-y-1 transition ease-in-out">Pay - ${post.price} USD (excl tax)</button>
                    //                                         </div>
                    //                                     </div>
                    //                                 }
                    //                             })()}
                    //                         </div>
                        
                    //                         <div id="postControls">
                    //                             <div className="flex gap-4 px-2 pt-4 text-lg">
                    //                                 <span className="text-white">
                    //                                     {(() => {
                    //                                         if (post.access === true) {
                    //                                             if (post.isPostLiked) {
                    //                                                 return <>
                    //                                                     <i className="fa-solid fa-heart text-red-500 hover:cursor-pointer" onClick={(e) => this.toggleLike(e, post.postID)}></i>
                    //                                                     <span className="ml-2">{formatLikes(post.likes)}</span>
                    //                                                     <span className="text-white hover:cursor-pointer ml-2" onClick={() => this.openCommentModal(post.postID)}>
                    //                                                         <i className="fa-regular fa-comment hover:cursor-pointer"></i>
                    //                                                         <span className="ml-2 hover:cursor-pointer">{formatComments(post.comments)}</span>
                    //                                                     </span>
                    //                                                 </>
                    //                                             } else {
                    //                                                 return <>
                    //                                                     <i className="fa-regular fa-heart hover:cursor-pointer" onClick={(e) => this.toggleLike(e, post.postID)}></i>
                    //                                                     <span className="ml-2">{formatLikes(post.likes)}</span>
                    //                                                     <span className="text-white hover:cursor-pointer ml-2" onClick={() => this.openCommentModal(post.postID)}>
                    //                                                         <i className="fa-regular fa-comment hover:cursor-pointer"></i>
                    //                                                         <span className="ml-2 hover:cursor-pointer">{formatComments(post.comments)}</span>
                    //                                                     </span>
                    //                                                 </>
                    //                                             }
                    //                                         } else {
                    //                                             return <>
                    //                                                 <i className="fa-regular fa-heart" onClick={(() => {
                    //                                                     toast.error('Purchase to like the post!', { style: {
                    //                                                         color: '#ffffff',
                    //                                                         backgroundColor: '#242C37',
                    //                                                     }});
                    //                                                 })}></i>
                    //                                                 <span className="ml-2" onClick={(() => {
                    //                                                     toast.error('Purchase to like the post!', { style: {
                    //                                                         color: '#ffffff',
                    //                                                         backgroundColor: '#242C37',
                    //                                                     }});
                    //                                                 })}>{formatLikes(post.likes)}</span>
                    //                                             </>
                    //                                         }
                    //                                     })()}
                    //                                 </span>
                    //                             </div>
                    //                         </div>
                    //                     </div>
                    //                 ))
                    //             }
                    //         })()}
                    // </InfiniteScroll>
                }
            })()}

            {(() => {
                if (this.state.isSelf) {
                    return <Transition appear show={this.state.profileModalShown}>
                        <Dialog as="div" className="relative z-30 focus:outline-none" onClose={() => this.closeProfileModal()}>
                            <div className="fixed inset-0 bg-black/80" aria-hidden="true" />
                            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                                <div className="flex min-h-full items-center justify-center p-4">
                                    <TransitionChild
                                        enter="ease-out duration-300"
                                        enterFrom="opacity-0 transform-[scale(95%)]"
                                        enterTo="opacity-100 transform-[scale(100%)]"
                                        leave="ease-in duration-200"
                                        leaveFrom="opacity-100 transform-[scale(100%)]"
                                        leaveTo="opacity-0 transform-[scale(95%)]"
                                    >
                                        <DialogPanel className="w-full max-w-md rounded-xl bg-gray-800 p-6 backdrop-blur-2xl">
                                            <DialogTitle as="h3" className="text-base/7 font-bold text-white">
                                                Set Display Name / Username
                                            </DialogTitle>
                                            <div className="flex grid grid-rows mt-4">
                                                {(() => {
                                                    if (this.state.user) {
                                                        return <>
                                                            <h1 className="text-white text-sm/6 font-bold">Display Name</h1>
                                                            {/* @ts-ignore */}
                                                            <input ref={this.displayNameInput} className="px-2 py-1 rounded-md bg-gray-900 mt-2 text-white" type="text" name="displayName" id="displayName" defaultValue={this.state.user.displayName} placeholder="Display Name ..." />
                                                            <h1 className="text-white text-sm/6 mt-2 font-bold">Username</h1>
                                                            {/* @ts-ignore */}
                                                            <input ref={this.usernameInput} className="px-2 py-1 rounded-md bg-gray-900 mt-2 text-white" type="text" name="username" id="username" defaultValue={this.state.user.username} placeholder="Username ..." /> 
                                                        </>
                                                    }
                                                })()}
                                            </div>
                                            {/* <p className="mt-2 text-sm/6 text-white/50">
                                                Your payment has been successfully submitted. We've sent you an email with all of the details of
                                                your order.
                                            </p> */}
                                            <div className="mt-6">
                                                <div className="flex grid grid-cols-2 gap-2">
                                                    <button className="px-2 py-1 bg-gray-700 rounded-md text-white" onClick={() => this.closeProfileModal()}>Cancel</button>
                                                    <button className="px-2 py-1 bg-red-600 rounded-md text-white"
                                                        onClick={() => this.updateProfile()}
                                                    >
                                                        {(() => {
                                                            if (this.state.profileUploading) {
                                                                return <span className="inline-flex"> <MoonLoader color="#ffffff" size={14} className="mt-[2px]" /> <span className="pl-2">Loading</span></span>;
                                                            } else {
                                                                return "Save Changes";
                                                            }
                                                        })()}
                                                    </button>
                                                    {/* <button
                                                        className="inline-flex items-center gap-2 rounded-md bg-gray-700 py-1.5 px-3 text-sm/6 font-semibold text-white shadow-inner shadow-white/10 focus:outline-none data-[hover]:bg-gray-600 data-[open]:bg-gray-700 data-[focus]:outline-1 data-[focus]:outline-white"
                                                        onClick={() => this.updateProfile()}
                                                    >
                                                        {(() => {
                                                            if (this.state.profileUploading) {
                                                                return <span className="inline-flex"> <MoonLoader color="#ffffff" size={14} className="mt-[2px]" /> <span className="pl-2">Loading</span></span>;
                                                            } else {
                                                                return "Save Changes";
                                                            }
                                                        })()}
                                                    </button> */}
                                                </div>
                                            </div>
                                        </DialogPanel>
                                    </TransitionChild>
                                </div>
                            </div>
                        </Dialog>
                    </Transition>
                }
            })()}

            {/* Purchase Modal */}
            <Transition appear show={this.state.purchaseShow}>
                <Dialog as="div" className="relative z-30 focus:outline-none" onClose={() => this.closePaymentModal()}>
                    <div className="fixed inset-0 bg-black/80" aria-hidden="true" />
                    <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4">
                            <TransitionChild
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 transform-[scale(95%)]"
                                enterTo="opacity-100 transform-[scale(100%)]"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 transform-[scale(100%)]"
                                leaveTo="opacity-0 transform-[scale(95%)]"
                            >
                                <DialogPanel className={`w-full max-w-md rounded-xl backdrop-blur-2xl ${
                                    (this.state.twoFacSuccess !== true && this.state.totpEnabled === true && this.state.userSuspended !== true) 
                                        ? '' 
                                        : 'bg-gray-800 p-6'
                                }`}>
                                    {(this.state.twoFacSuccess === true && this.state.totpEnabled === true) && (
                                        <DialogTitle as="h3" className="text-2xl font-bold text-white">
                                            Purchase Post
                                        </DialogTitle>
                                    )}

                                    {(() => {
                                        if (this.state.twoFacSuccess === true && this.state.totpEnabled === true) {
                                            if (this.state.purchaseData !== null) {
                                                return <div className="mt-6 text-white">
                                                    <div>
                                                        <h3 className="font-bold mt-4 mb-4 text-lg">Payment Summary</h3>
                                                    
                                                        {(() => {
                                                            return <Tabs
                                                                items={this.state.paymentProviders.map((provider) => {
                                                                    return {
                                                                        key: provider.provider,
                                                                        label: provider.label,
                                                                        render: () => {
                                                                            if (provider.provider === 'Stripe') {
                                                                                return <EmbeddedCheckoutProvider
                                                                                    stripe={this.loadStripeComponent()}
                                                                                    options={this.checkoutSession(this.state.purchaseData?.postID)}
                                                                                >   
                                                                                    {(() => {
                                                                                        setTimeout(() => {
                                                                                            var iframe = document.getElementsByName('embedded-checkout')[0];
                                                                                            if (iframe) {
                                                                                                iframe.style.borderRadius = '0.375rem';
                                                                                            }
                                                                                        }, 1000);

                                                                                        if (this.state.isPaymentActive) {
                                                                                            return <div className="flex justify-center">
                                                                                                <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-red-500"></div>
                                                                                            </div>
                                                                                        }
                                                                                    })()}
                                                                                    <EmbeddedCheckout />
                                                                                </EmbeddedCheckoutProvider>
                                                                            } else {
                                                                                return <>
                                                                                    
                                                                                </>
                                                                            }
                                                                        }
                                                                    }
                                                            })} />
                                                        })()}
                                                    </div>

                                                    <button ref={this.closeModalBTN} onClick={() => this.closePaymentModal()} className="w-full text-red-500 px-2 py-1.5 bg-gray-900 disabled:bg-gray-700 rounded-md mt-2">Cancel</button>
                                                </div>
                                            }
                                        } else if (this.state.totpEnabled === false ) {
                                            return <div className="mt-4">
                                                <div className="mb-4">
                                                    <h3 className="text-white text-lg">To make a purchase please enable Two Factor Authentication under account security settings.</h3>
                                                </div>
                                                <a href={`${process.env.REACT_APP_URL}app/settings#/security`} className="text-white bg-gray-900 rounded-md px-3 py-2 mt-4" target='_blank' rel="noreferrer">Go to Security Settings <i className="fa-sharp fa-solid fa-right px-2"></i></a>
                                            </div>
                                        } else if (this.state.userSuspended === true) {
                                            return <div className="w-full">
                                                <p className="text-white mt-2">Unfortunately your account is suspended. You cannot make any new purchases, subscribe to creators, watch livestreams or comment/like content. You can still access previously purchased content.</p>
                                            </div>
                                        } else {
                                            // return <div className="w-full">
                                            //     <h3 className="text-white">Please enter your 2FA code to continue!</h3>
                                            //     <AuthCode 
                                            //         autoFocus={true} 
                                            //         ref={this.AuthInputRef}
                                            //         allowedCharacters='numeric' 
                                            //         onChange={(e) => this.authCodeInput(e)} 
                                            //         containerClassName='auth-container'
                                            //         inputClassName='auth-input'
                                            //     />
                                            //     <button ref={this.closeModalBTN} onClick={() => this.closePaymentModal()} className="w-full text-red-500 px-2 py-1.5 bg-gray-900 disabled:bg-gray-700 rounded-md mt-2">Cancel</button>
                                            // </div>
                                            return <TwoFacModal
                                                onSuccess={() => this.setState({ twoFacSuccess: true })}
                                                onCancel={() => this.closePaymentModal()}
                                            />
                                        }
                                    })()}
                                </DialogPanel>
                            </TransitionChild>
                        </div>
                    </div>
                </Dialog>
            </Transition>

            <Transition appear show={this.state.reportModal} >
                <Dialog as="div" className="relative z-30 focus:outline-none" onClose={() => this.closeModal('report')} >
                    <div className="fixed inset-0 bg-black/80" aria-hidden="true" />
                    <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4">
                            <TransitionChild
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 transform-[scale(95%)]"
                                enterTo="opacity-100 transform-[scale(100%)]"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 transform-[scale(100%)]"
                                leaveTo="opacity-0 transform-[scale(95%)]"
                            >
                                <DialogPanel className="w-full max-w-md rounded-xl bg-gray-800 p-6 backdrop-blur-2xl">
                                    <DialogTitle as="h3" className="text-2xl font-bold text-white">
                                        Report an issue
                                    </DialogTitle>
                                    <div className="mt-4">
                                        <form className="grid grid-cols-1 gap-4" onSubmit={(e) => this.submitReport(e)}>
                                            <div className="flex flex-col">
                                                <label className="mb-2 text-white font-bold text-md">Title</label>
                                                <input onChange={(e) => this.reportForm(e.target.value, 'title')} required className="rounded-md p-2 bg-gray-900 text-white shadow-md" placeholder="Title ..." />
                                            </div>
                                            <div className="flex flex-col">
                                                <label className="mb-2 text-white font-bold text-md">Issue Category</label>
                                                <select onChange={(e) => this.reportForm(e.target.value, 'category')} required className="rounded-md p-2 bg-gray-900 text-white shadow-md">
                                                    <option value=""></option>
                                                    <option value="bug">Bug</option>
                                                    <option value="copyright">Copyright Infringement</option>
                                                    <option value="tos">Breach TOS</option>
                                                    <option value="support">Support</option>
                                                    <option value="content">Inappropriate Content</option>
                                                    <option value="other">Other</option>
                                                </select>
                                            </div>
                                            <div className="flex flex-col">
                                                <label className="mb-2 text-white font-bold text-md">Description</label>
                                                <textarea onChange={(e) => this.reportForm(e.target.value, 'desc')} defaultValue={this.state.reportModalDescription} required className="rounded-md p-2 bg-gray-900 text-white shadow-md" rows={4} placeholder="Issue Description, where it happened? (post title/page name), previous steps leading up till the issue ..."></textarea>
                                            </div>
                                            <div className="flex grid grid-cols-2 gap-4">
                                                <span onClick={() => this.closeModal('report')} className="bg-gray-900 text-white rounded-md p-2 mt-2 text-center hover:cursor-pointer shadow-md">Cancel</span>
                                                <button ref={this.reportSubmit} disabled type="submit" className="bg-red-600 disabled:bg-red-400 text-white rounded-md p-2 mt-2 shadow-md">Submit</button>
                                            </div>
                                        </form>
                                    </div>
                                </DialogPanel>
                            </TransitionChild>
                        </div>
                    </div>
                </Dialog>
            </Transition>

            {/* Edit Modal */}
            <Transition appear show={this.state.editModal} >
                <Dialog as="div" className="relative z-30 focus:outline-none" onClose={() => this.closeModal('edit')} >
                    <div className="fixed inset-0 bg-black/80" aria-hidden="true" />
                    <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4">
                            <TransitionChild
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 transform-[scale(95%)]"
                                enterTo="opacity-100 transform-[scale(100%)]"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 transform-[scale(100%)]"
                                leaveTo="opacity-0 transform-[scale(95%)]"
                            >
                                <DialogPanel className="w-full max-w-md rounded-xl bg-gray-800 p-6 backdrop-blur-2xl">
                                    <DialogTitle as="h3" className="text-2xl font-bold text-white">
                                        Edit Post
                                    </DialogTitle>
                                    <div className="mt-4">
                                        <form className="grid grid-cols-1 gap-4" onSubmit={(e) => this.submitEdit(e)}>
                                            <div className="flex flex-col">
                                                <label className="mb-2 text-white font-bold text-md">Title</label>
                                                <input onChange={(e) => this.editForm(e.target.value, 'title')} required defaultValue={this.state.editTitle} className="rounded-md p-2 bg-gray-900 text-white shadow-md" placeholder="Title ..." />
                                            </div>
                                            <div className="flex flex-col">
                                                <label className="mb-2 text-white font-bold text-md">Description</label>
                                                <textarea onChange={(e) => this.editForm(e.target.value, 'desc')} defaultValue={this.state.editDesc} required className="rounded-md p-2 bg-gray-900 text-white shadow-md" rows={4} placeholder="Post Description ..."></textarea>
                                            </div>
                                            <div className="flex grid grid-cols-2 gap-4">
                                                <span onClick={() => this.closeModal('edit')} className="bg-gray-900 text-white rounded-md p-2 mt-2 text-center hover:cursor-pointer shadow-md">Cancel</span>
                                                <button ref={this.editSubmit} type="submit" className="bg-red-600 disabled:bg-red-400 text-white rounded-md p-2 mt-2 shadow-md">Submit</button>
                                            </div>
                                        </form>
                                    </div>
                                </DialogPanel>
                            </TransitionChild>
                        </div>
                    </div>
                </Dialog>
            </Transition>

            {/* Takedown Modal */}
            <Transition appear show={this.state.takedownModal} >
                <Dialog as="div" className="relative z-30 focus:outline-none" onClose={() => this.closeModal('takedown')} >
                    <div className="fixed inset-0 bg-black/80" aria-hidden="true" />
                    <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4">
                            <TransitionChild
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 transform-[scale(95%)]"
                                enterTo="opacity-100 transform-[scale(100%)]"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 transform-[scale(100%)]"
                                leaveTo="opacity-0 transform-[scale(95%)]"
                            >
                                <DialogPanel className="w-full max-w-md rounded-xl bg-gray-800 p-6 backdrop-blur-2xl">
                                    <DialogTitle as="h3" className="text-2xl font-bold text-white">
                                        Take Down Post: {this.state.takedownTitle}
                                    </DialogTitle>
                                    <div className="mt-4">
                                        <form className="grid grid-cols-1 gap-4" onSubmit={(e) => this.submitEdit(e)}>
                                            {/* Show are you sure dialog */}
                                            <div className="text-white">
                                                <p>Are you sure you want to take down this post? This action cannot be undone.</p>
                                                <p className="font-bold mt-4">Anyone who has previously purchased the post will retain access, however for everyone else the post will no longer become available on your profile to your followers. </p>
                                                {/* <p className="font-bold mt-4">All access to this post will be removed and it will no longer be available on your profile or to your followers.</p> */}
                                                <p className="mt-4">If you want to edit the post instead, please use the edit option.</p>
                                            </div>
                                            <div className="flex grid grid-cols-2 gap-4">
                                                <span onClick={() => this.closeModal('takedown')} className="bg-gray-900 text-white rounded-md p-2 mt-2 text-center hover:cursor-pointer shadow-md">Cancel</span>
                                                <button onClick={(e) => this.takedownPost(e)} type="button" className="bg-red-600 disabled:bg-red-400 text-white rounded-md p-2 mt-2 shadow-md">Take Down Post</button>
                                            </div>
                                        </form>
                                    </div>
                                </DialogPanel>
                            </TransitionChild>
                        </div>
                    </div>
                </Dialog>
            </Transition>

            {/* Subscription Modal ... */}
            <Transition appear show={this.state.followModal}>
                <Dialog as="div" className="relative z-30 focus:outline-none" onClose={() => this.setState({ followModal: false})}>
                    <div className="fixed inset-0 bg-black/80" aria-hidden="true" />
                    <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4">
                            <TransitionChild
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 transform-[scale(95%)]"
                                enterTo="opacity-100 transform-[scale(100%)]"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 transform-[scale(100%)]"
                                leaveTo="opacity-0 transform-[scale(95%)]"
                            >
                                <DialogPanel className="w-full max-w-md rounded-xl bg-gray-800 p-6 backdrop-blur-2xl">
                                    <DialogTitle as="h3" className="text-2xl font-bold text-white">
                                        Follow
                                    </DialogTitle>

                                    <div className="mt-6 text-white">
                                        {(() => {
                                            // console.log(this.state.totpEnabled, this.state.twoFacSuccess);
                                            if (this.state.twoFacSuccess === true && this.state.totpEnabled === true) {
                                                if (this.state.planID !== null) {
                                                    return <div>
                                                        <div>
                                                            <h3 className="font-bold mt-4 mb-4 text-lg">Payment Summary</h3>
                
                                                            <EmbeddedCheckoutProvider
                                                                stripe={this.loadStripeComponent()}
                                                                options={this.subscriptionSession(this.state.planID)}
                                                            >   
                                                                {(() => {
                                                                    setTimeout(() => {
                                                                        var iframe = document.getElementsByName('embedded-checkout')[0];
                                                                        if (iframe) {
                                                                            iframe.style.borderRadius = '0.375rem';
                                                                        }
                                                                    }, 1000);
                
                                                                    if (this.state.isPaymentActive) {
                                                                        return <div className="flex justify-center">
                                                                            <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-red-500"></div>
                                                                        </div>
                                                                    }
                                                                })()}
                                                                <EmbeddedCheckout />
                                                            </EmbeddedCheckoutProvider>
                                                        </div>
                                                        <button onClick={() => this.setState({followModal: false})} className="w-full text-red-500 px-2 py-1.5 bg-gray-900 disabled:bg-gray-700 rounded-md mt-2">Cancel</button>
                                                    </div>
                                                }
                                            } else if (this.state.totpEnabled === false) {
                                                return <div className="mt-4">
                                                    <div className="mb-4">
                                                        <h3 className="text-white text-lg">To make a purchase please enable Two Factor Authentication under account security settings.</h3>
                                                    </div>
                                                    <a href={`${process.env.REACT_APP_URL}app/settings#/security`} className="text-white bg-gray-900 rounded-md px-3 py-2 mt-4" target='_blank' rel="noreferrer">Go to Security Settings <i className="fa-sharp fa-solid fa-right px-2"></i></a>
                                                </div>
                                            } else if (this.state.userSuspended === true) {
                                                return <div className="w-full">
                                                    <p className="text-white mt-2">Unfortunately your account is suspended. You cannot make any new purchases, subscribe to creators, watch livestreams or comment/like content. You can still access previously purchased content.</p>
                                                </div>
                                            } else {
                                                return <div className="w-full">
                                                <h3 className="text-white">Please enter your 2FA code to continue!</h3>
                                                <AuthCode 
                                                    autoFocus={true} 
                                                    ref={this.AuthInputRef}
                                                    allowedCharacters='numeric' 
                                                    onChange={(e) => this.authCodeInput(e)} 
                                                    containerClassName='auth-container'
                                                    inputClassName='auth-input'
                                                />
                                                <button onClick={() => this.setState({followModal: false})} className="w-full text-red-500 px-2 py-1.5 bg-gray-900 disabled:bg-gray-700 rounded-md mt-2">Cancel</button>
                                            </div>
                                            }
                                        })()}

                                        {/* <button onClick={() => this.setState({followModal: false})} className="w-full text-red-500 px-2 py-1.5 bg-gray-900 disabled:bg-gray-700 rounded-md mt-2">Cancel</button> */}
                                    </div>
                                </DialogPanel>
                            </TransitionChild>
                        </div>
                    </div>
                </Dialog>
            </Transition>

            {/* Comments Modal... */}
            <Transition appear show={this.state.commentModal}>
                <Dialog as="div" className="relative z-30 focus:outline-none" onClose={() => this.closeCommentModal()}>
                    <div className="fixed inset-0 bg-black/80" aria-hidden="true" />
                    <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4">
                            <TransitionChild
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 transform-[scale(95%)]"
                                enterTo="opacity-100 transform-[scale(100%)]"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 transform-[scale(100%)]"
                                leaveTo="opacity-0 transform-[scale(95%)]"
                            >
                                <DialogPanel className="w-full max-w-md rounded-xl bg-gray-800 p-6 backdrop-blur-2xl">
                                    <DialogTitle as="h3" className="text-2xl font-bold text-white">
                                        Comments
                                    </DialogTitle>
                                    <div className="flex grid grid-rows mt-6 text-white gap-2 overflow-y-auto max-h-96">
                                        {this.state.comments?.map((comment: any, index: any) => {
                                            return (
                                                <div className="flex items-start gap-4" key={index}>
                                                    {(() => {
                                                        if (comment.profilePic === null || comment.profilePic === undefined || comment.profilePic === '') {
                                                            return (
                                                                // <span className="min-h-10 min-w-10 rounded-full bg-red-600 inline-block"></span>
                                                                <img src={ProfilePic} className="h-10 w-10 rounded-full" />
                                                            );
                                                        } else {
                                                            return (
                                                                <img src={comment.profilePic} className="h-10 w-10 rounded-full inline-block" />
                                                            );
                                                        }
                                                    })()}
                                                    <div className="w-full">
                                                        <div className="flex justify-between">
                                                            <h3 className="text-white font-bold">{(() => {
                                                                if (comment.isCreator) {
                                                                    return <i className="fa-solid fa-badge-check text-sky-500" title="Verified Creator" />
                                                                }
                                                            })()} {comment.displayName} <span className="text-gray-400 text-sm">{commentDateFormat(comment.createdAt)}</span>
                                                            {/* <i className="fa-regular fa-flag text-gray-400 text-sm hover:text-white hover:cursor-pointer"></i> */}
                                                            </h3>
                                                            {/* <button 
                                                                className="text-gray-400 px-2 py-1 hover:bg-gray-900 hover:rounded-md" 
                                                                aria-label="More options"
                                                            >
                                                                <i className="fa-solid fa-ellipsis-vertical"></i>
                                                            </button> */}
                                                            {/* <span className="text-gray-400 px-2 py-1 hover:bg-gray-900 hover:rounded-md"><i className="fa-solid fa-ellipsis-vertical"></i></span> */}
                                                            
                                                            {this.state.isSelf && (
                                                                <div className="relative">
                                                                    <button
                                                                        onClick={() => this.commentBanUser(comment.userID, comment.contentID)}
                                                                        className="text-red-500 px-2 py-1 hover:bg-gray-900 hover:rounded-md"
                                                                        aria-label="Ban User"
                                                                    >
                                                                        <i className="fa-solid fa-hammer"></i>
                                                                    </button>
                                                                    {/* {this.state.openCommentMenuIndex === index && (
                                                                        <div className="absolute right-0 mt-2 w-32 z-50 bg-gray-800 rounded-md shadow-lg py-2 border border-gray-700">
                                                                            <button
                                                                                className="block w-full text-left px-4 py-2 text-red-500 hover:bg-gray-700"
                                                                                onClick={() => this.banUserFromComments(comment.username)}
                                                                            >
                                                                                Ban User
                                                                            </button>
                                                                        </div>
                                                                    )} */}
                                                                </div>
                                                            )}
                                                        </div>
                                                        <p className="text-white">{comment.comment}</p>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                    <div>
                                        {/* Input */}
                                        <div className="mt-6">
                                            <form onSubmit={(e) => this.submitComment(e)}>
                                                <div className="flex grid grid-cols-4 gap-2">
                                                    <input ref={this.commentInput} onChange={(e) => this.setState({commentData: e.target.value})} className="px-2 py-1 col-span-3 rounded-md bg-gray-900 w-full text-white" type="text" placeholder="Comment ..." />
                                                    <button className="px-2 py-1 bg-gray-900 rounded-md text-white">Submit</button> {/* bg-gray-700 */}
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </DialogPanel>
                            </TransitionChild>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </div>
    }
}